/**
 * Plugin
 */
import { HttpClient } from '@angular/common/http';
import { Component, HostListener, ViewChild } from '@angular/core';
import { AppMinimize } from '@ionic-native/app-minimize';
/**
 * Native
 */
import { AppVersion } from '@ionic-native/app-version';
import { Deeplinks } from '@ionic-native/deeplinks';
import { Device } from '@ionic-native/device';
import { Diagnostic } from '@ionic-native/diagnostic';
import { FileTransfer } from '@ionic-native/file-transfer';
import { Geolocation } from '@ionic-native/geolocation';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
import { Keyboard } from '@ionic-native/keyboard';
import { LaunchReview } from '@ionic-native/launch-review';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { Network } from '@ionic-native/network';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { StatusBar } from '@ionic-native/status-bar';
import { Storage } from '@ionic/storage';
// import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as async from 'async';
import { AlertController, App, Content, Events, IonicApp, LoadingController, ModalController, Nav, Platform, Toast, ToastController } from 'ionic-angular';
import * as moment from "moment";
import "rxjs/add/operator/map";
import { Subscription } from 'rxjs/Subscription';
import { AuthenticationBloc } from '../bloc/authentication/authentication.bloc';
import { InitializeBloc } from '../bloc/authentication/initialize.bloc';
import { ActivityRecordingBloc } from '../bloc/feature/activity-recording/activity-recording.bloc';
import { BackgroundGeolocationBloc } from '../bloc/feature/background-geolocation/background-geolocation.bloc';
import { PollingBloc } from '../bloc/feature/polling/polling.bloc';
import { TrackerBloc } from '../bloc/feature/tracker/tracker.bloc';
import { AttendanceBloc } from '../bloc/hr/attendance/attendance.bloc';
import { EventLabel } from '../helpers/event-label';
import { EventNameAnalytics } from '../helpers/event-name-analytics';
import { Messages } from '../helpers/messages';
import RootPage from '../helpers/root-page.helper';
import { AttendanceOfflineData, ResponseAttendanceMachine } from '../model/attendance/attendance-preview.model';
import { GDAuthInterface } from '../model/gd-auth';
import { BackgroundGeolocationNative } from "../native/background-geolocation.native";
import { FcmNative, INotificationPayload } from '../native/fcm.native';
import { GeolocationNative } from "../native/geolocation.native";
import { PageBuilderGlobal } from '../pagebuilder/providers/global';
import { MenuProvider } from '../pagebuilder/services/menu/menu';
import { PageBuilderMenuProvider } from '../pagebuilder/services/menu/repository';
import { PageBuilderFeaturePageProvider } from '../pagebuilder/services/schema/feature-page-service';
import { AttendanceResultPage } from '../pages/attendance-result/attendance-result';
import { Home2Page } from '../pages/general/home2/home2';
import { HomePage } from '../pages/home-tabs/home/home';
import { TimeAttendanceSfgoPage } from '../pages/hr/time-attendance/sfgo/time-attendance-sfgo/time-attendance-sfgo';
import { TimeAttendance } from '../pages/hr/time-attendance/time-attendance';
import { AlertServiceProvider } from '../providers/alert-service/alert-service';
import { AppGuideProviders } from '../providers/app-guide/appGuideProviders';
import { ChatSupportService } from '../providers/chat-support/chat-support-service';
import { FcmServiceProvider } from "../providers/fcm-service/fcm-service";
import { FirebaseMessagingProvider } from "../providers/fcm-service/firebase-messaging";
import { GlobalServiceProvider } from '../providers/global-service/global-service';
import { HomeFeedStateProvider } from '../providers/management-state/homefeed.state';
import { NavigationService } from '../providers/navigation/navigation';
/**
 * Providers
 */
import { PermissionCheckProvider } from '../providers/permission-check/permission-check';
import { Pinger } from '../providers/pinger/pinger';
import { PlatformServiceProvider } from '../providers/platform/platform-service';
import { SaasProvider } from '../providers/saas/saas';
import { SFGOAuthService } from '../providers/sfgoauth.service/sfgoauth.service';
import { SocketIoClientProvider } from '../providers/socket-io-client/socket-io-client';
import { StoragePathProvider } from '../providers/storage-path/storage-path';
import { AppPreferences, Preference } from '../shared/local/app-preferences.local';
import { ActivityProvider } from "../shared/nestjs/activity-recording/activity";
import { RequestRecordTimeBarcodeGdDto, RequestRecordTimeBarcodeSF6Dto, RequestRecordTimeGdDto, RequestRecordTimeSF6Dto } from '../shared/nestjs/gd-only/dto/attendance.dto';
import { AttendanceApi } from '../shared/nestjs/gd-only/services/attendance.api';
import { AuthApi } from '../shared/nestjs/gd-only/services/auth.api';
/**
 * SDK
 */
import { SunfishNestApi } from "../shared/nestjs/gd-only/services/sunfish.api";
import { TrackerApi } from "../shared/nestjs/gd-only/services/tracker.api";
import { NestApiProvider } from "../shared/nestjs/nest-api";
import { NestResponsesProvider } from '../shared/nestjs/nest-responses';
import { ActivityServiceApi } from '../shared/sdk';
import { ApiServiceProvider } from './../pagebuilder/services/api/api-service';
import { PageBuilderVersionProvider } from './../pagebuilder/services/version/version-service';
import { AnalyticsProvider } from './../providers/analytics/analytics';
import { LoopBackAuth as LoopBackAuthBudget } from './../shared/sdk-budget/services/core/auth.service';
/**
 * SDK Budget
 */
import { ScreenshotNative } from '../native/screenshot.native';
import { MemberApi } from './../shared/sdk-budget/services/custom/Member';
import { LoopBackConfig } from './../shared/sdk/lb.config';
import { LoopBackAuth } from './../shared/sdk/services/core/auth.service';
import { AccessmanagementApi } from './../shared/sdk/services/custom/Accessmanagement';
import { BuilderServiceApi } from './../shared/sdk/services/custom/BuilderService';
import { SFAttendanceApi } from './../shared/sdk/services/custom/SFAttendance';
import { SFAttUploadSF6Api } from './../shared/sdk/services/custom/SFAttUploadSF6';
import { SfgisServiceApi } from './../shared/sdk/services/custom/SfgisService';
import { SFProfileApi } from './../shared/sdk/services/custom/SFProfile';
import { SunfishApi } from './../shared/sdk/services/custom/Sunfish';
import { TclmuserApi } from './../shared/sdk/services/custom/Tclmuser';
// import { CompanyMoodBloc } from '../bloc/feature/company-mood/company-mood.bloc';
declare var android;
declare var window;
declare var greatdayplugin;
declare const SecurityCheck;
declare var cordova;
@Component({
  templateUrl: 'app.html',
  selector: 'app-component'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  @ViewChild(Content) content: Content;

  public rootPage: any = "PageInitPage";
  public auth_user: any;
  public activePage = 0;
  public name: string;
  public photo: string;
  public position: string;
  public empId: string;
  public userid: any;
  public deployText = '';
  public dataEmployee: any;
  public userData: any;
  public isLoadMenu: Boolean = false;
  public pages: any = [];
  public customPages: Array<{ title: string, page: any, icon: any, auth: any, show: boolean, badgeshow: boolean, badgetext: string, newicon: boolean, newiconfile: string }>;
  public sunfishCustomPages: Array<{ title: string, component: any, icons: any, show: boolean, params: any, newicon: boolean, newiconfile: string }>;
  public subscriptions: Array<Subscription> = [];
  public tambahSize: any = 'bukaSizeMenu';
  public maxMenuTab = 1420;

  //var to hold custom page from pagebuilder
  public builderMenus: any;

  // loading region
  public radius: any;
  public diameter: any = 57;
  public halfDiameter: any;
  public borderWidth: any = 3;
  public diameterStretch: any;
  public circleProgress: any;
  public circlePercentage: any;
  public loadFile: any = 0;
  public totalFile: any = 149;
  public toggleHide: boolean = false;
  // end loading

  // start payroll HD
  public userIdProcessBy: any
  public empIdProcessBy: any
  public empPhoto: any
  // end payroll HD

  //add for multicompany "AR"
  public selectCompany: any = [];
  public selectCom: any = [];

  public empphotopath: any;
  public companyphotopath: any;

  public isSF6 = false;
  public isSPV = false;

  /**
   * Version
   */
  public versionCode: any;
  public versionNumber: any;
  public versionShow = 1;

  /**
   * Sync
   */
  public isSync: any = false;
  public isLarge: boolean;

  /**
   * Swipe
   */
  public sideEnable: boolean;
  public swipeEnabled: any = true;
  public showToast: any = true;
  public showKeyboard: any = false;

  /**
   * OFFLINE MODE VARIABLE
   */
  public isOnline: any;
  public isOnlineServer: any = true;
  public isLogout: boolean = false;
  public isOfflineMode: boolean = false;
  public isShowOfflineModeMenu: boolean = false;
  public isPagePreviewAttendance: boolean = false;
  public runPing: any = false;
  public runPingServer: any = false;
  public intervalserver: any;
  public intervalgoogle: any;
  public intervalConnection: any;
  public itervalTotalSuccessOnline: any = 0;

  /**
   * Alert Error
   */
  public showError: boolean = false;
  public appUpdate: boolean = false;
  public loadBirthday: any = false;
  public toggleChatNotif: boolean = false;

  //notification
  public goPathNew: boolean = false;
  public messaging: any;
  public fcmToken: any;
  public app_key: any;

  public dummyPages: any;
  public screenWidth: any;
  public sidebarScroll: any;
  public newHome: boolean;
  public dataNotif: Subscription;
  public isMobile: boolean = false;
  public toggleSnackbar: boolean = false;
  public attOfflineList: Array<any> = [];
  public countOnConnect: number = 0;
  public SFGoAuth: GDAuthInterface;
  public android: any;
  public toastList: any = [];
  public isClickMenu = false;
  public runIframe: boolean = false;

  public isSF7: boolean = false;
  public activeTab = 'HomePage';
  constructor(
    public statusBar: StatusBar,
    public platform: Platform,
    public app: App,
    public sunfishApi: SunfishApi,
    public alertCtrl: AlertController,
    public tclmuserApi: TclmuserApi,
    public toastCtrl: ToastController,
    public events: Events,
    public ionicApp: IonicApp,
    public storage: Storage,
    public translate: TranslateService,
    public modalCtrl: ModalController,
    public appVersion: AppVersion,
    public network: Network,
    public geolocation: Geolocation,
    public localNotifications: LocalNotifications,
    public transfer: FileTransfer,
    public sfattuploadsf6Api: SFAttUploadSF6Api,
    public sfattendanceApi: SFAttendanceApi,
    public auth: LoopBackAuth,
    public launchReview: LaunchReview,
    public diagnostic: Diagnostic,
    public screenOrientation: ScreenOrientation,
    public permissionCheckProvider: PermissionCheckProvider,
    public storagePathProvider: StoragePathProvider,
    public device: Device,
    public accessmanagementapi: AccessmanagementApi,
    public builderServiceApi: BuilderServiceApi,
    public sfgisServiceApi: SfgisServiceApi,
    private keyboard: Keyboard,
    private deeplinks: Deeplinks,
    private pinger: Pinger,
    public memberApi: MemberApi,
    public authBudget: LoopBackAuthBudget,
    public analyticsProvider: AnalyticsProvider,
    public socketIoClientProvider: SocketIoClientProvider,
    public inAppBrowser: InAppBrowser,
    public http: HttpClient,
    public sfProfileApi: SFProfileApi,
    public attendanceBloc: AttendanceBloc,
    public globalService: GlobalServiceProvider,
    public gdAttendanceApi: AttendanceApi,
    public fcmServiceProvider: FcmServiceProvider,
    private fcm: FcmNative,
    public firebaseMessagingProvider: FirebaseMessagingProvider,
    public menuService: MenuProvider,
    private menuRepository: PageBuilderMenuProvider,
    private versionServiceProvider: PageBuilderVersionProvider,
    public activityApi: ActivityServiceApi,
    private activityProvider: ActivityProvider,
    private nestApiProvider: NestApiProvider,
    public loadingCtrl: LoadingController,
    public appGuideProviders: AppGuideProviders,
    public homeFeedStateProvider: HomeFeedStateProvider,
    public saasProvider: SaasProvider,
    public sfgoAuthService: SFGOAuthService,
    public authNestApi: AuthApi,
    public nestResponse: NestResponsesProvider,
    private sunfishNestApi: SunfishNestApi,
    private initializeBloc: InitializeBloc,
    private alertService: AlertServiceProvider,
    private appPreferences: AppPreferences,
    private backgroundGeolocationNative: BackgroundGeolocationNative,
    private geolocationNative: GeolocationNative,
    private trackerApi: TrackerApi,
    public pollingBloc: PollingBloc,
    private apiServiceProvider: ApiServiceProvider,
    private backgroundGeolocationBloc: BackgroundGeolocationBloc,
    private _pageBuilderGlobal: PageBuilderGlobal,
    private authenticationBloc: AuthenticationBloc,
    private activityRecordingBloc: ActivityRecordingBloc,
    private trackerBloc: TrackerBloc,
    private navigationService: NavigationService,
    private appMinimize: AppMinimize,
    private platformServiceProvider: PlatformServiceProvider,
    private featurePageServiceProvider: PageBuilderFeaturePageProvider,
    private chatSupportService: ChatSupportService,
    private screenshotNative: ScreenshotNative,
  ) {
    this.screenWidth = window.innerWidth;
    this.initializeBloc.initLanguage();
    this.initializeApp();
    this.defineEvents();
    this.fcmNotification();
    this.initializeBloc.removeServiceWorker();
    this.detectBrowserRefresh();
    // this.getAppVersion();
    this.payrollQueue();
    this.regionLoading();
    this.loadFavMenu();
    this.initializeBloc.loadEmergencyAnnouncement();
    this.getInfoIdfa();
    this.initLocalTime();

    try {
      this.runIframe = (window.self !== window.top);
    } catch (e) {
      this.runIframe = false;
    }

    try {
      this.android = android;
    } catch (error) {
      this.android = null;
    }
  }

  ngAfterContentInit() {
    console.log('ngAfterContentInit()');
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter()');
  }

  ionViewWillLeave() {
    console.log('ionViewWillLeave()');
  }

  ionViewDidLeave() {
    console.log('ionViewDidLeave()');
  }

  async ngOnInit() {
    // await this.loadCheckTempering();
    await this.checkRunOnVirtual();
    // await this.checkReverseEngineering();

    this.reloadToRoot();
    this.initializeBloc.detectGooglePlayService();
    this.initializeBloc.detectGoogleMaps();
    this.onClickBrowserNavigation();
    if (window.innerWidth > this.maxMenuTab) {
      this.tambahSize = 'bukaSizeMenu';
    } else if (window.innerWidth >= 768 && window.innerWidth <= this.maxMenuTab) {
      this.tambahSize = 'tutupSizeMenu';
    }

    this.removeDirectory();
    /** SET HOST NEST API */
    await this.nestApiProvider.initializeAuth();
    /** GET AUTH */
    this.SFGoAuth = await this.appPreferences.getAuth();

    try {
      if (this.SFGoAuth) this.loadSettingScreenshot(this.SFGoAuth.companySetting.preventScreenshot);
    } catch (error) { }

    this.events.subscribe('toastCreate', (data) => {
      this.toastList.push({
        title: data.title,
        desc: data.desc,
        ctaLabel: data.ctaLabel,
        ctaClose: data.ctaClose
      })
      if (data.duration) {
        setTimeout(() => {
          this.toastList = this.toastList.filter((el) => el.title !== data.title);
        }, data.duration);
      }
    });
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy()');
    this.subscriptions.forEach(subs => subs.unsubscribe);
    this.events.unsubscribe('attendance:success-record-attendance');
    this.events.unsubscribe('profile:change-profile-picture');
    this.events.unsubscribe('user:updatepicture');
    this.events.unsubscribe('user:updateprofile');
    this.events.unsubscribe('user:created');
    this.events.unsubscribe('post:loadhome');
    this.events.unsubscribe(EventLabel.OPEN_MAPS_GREATDAY_PAGE);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth > this.maxMenuTab) {
      this.tambahSize = 'bukaSizeMenu';
    } else if (window.innerWidth >= 768 && window.innerWidth <= this.maxMenuTab) {
      this.tambahSize = 'tutupSizeMenu';
    }
  }

  async reStartBackgroundTracking() {
    try {
      /** RESTART TRACKING JIKA BACKGROUND LOCATION MATI */
      await this.trackerBloc.reStartTracker();
    } catch (error) {
      console.log('TCL: error restartTracker');
    }
  }

  async fcmPermission() {
    const wasPermissionGiven: boolean = await this.fcm.requestPushPermission({
      ios9Support: {
        timeout: 10,  // How long it will wait for a decision from the user before returning `false`
        interval: 0.3 // How long between each permission verification
      }
    });
    console.log('TCL: fcm permission', wasPermissionGiven);
  }

  /**
   * Handle Firebase Cloud Messaging Notification
   */
  fcmNotification() {
    this.platform.ready().then(async () => {
      if (this.platform.is('cordova')) {
        if (!this.platform.is('android')) {
          await this.fcmPermission();
        }

        const pushPayload: INotificationPayload = await this.fcm.getInitialPushPayload();
        console.log('TCL: ONPushPayload', pushPayload)

        if (pushPayload && pushPayload.wasTapped) {
          this.firebaseMessagingProvider.isNotifActive = true;
          this.firebaseMessagingProvider.isNotification.next(pushPayload);
        }

        this.fcm.onNotification().subscribe(async (data) => {
          console.log('TCL: FCM ONNOTIFICATION', data)
          if (data.wasTapped) {
            this.firebaseMessagingProvider.isNotifActive = true;
            this.firebaseMessagingProvider.isNotification.next(data);
          } else {
            console.log('TCL: NOTIF FOREGROUND', data)
            if (this.platform.is('android')) {
              console.log('TCL: PLATFORM IS ANDROID')
              this.localNotifications.schedule([{
                id: 1,
                title: data.title,
                text: data.body,
                data: data
              }]);

              if (this.dataNotif) {
                this.dataNotif.unsubscribe()
              }

              console.log('notif', this.dataNotif)

              this.dataNotif = this.localNotifications.on('click').subscribe(async () => {
                const fcmGoToPage = await this.initializeBloc.fcmGoToPage(data);
                if (fcmGoToPage.setPage.length) {
                  this.nav.setPages(fcmGoToPage.setPage);
                }
              })
            }
          }
        });
      }
    })
  }

  update(loadFile, totalFile) {
    this.loadFile = loadFile;
    this.totalFile = totalFile;
    if (this.loadFile < this.totalFile) {
      this.circlePercentage = Math.floor((this.loadFile / this.totalFile) * 100);
      this.circleProgress = this.diameterStretch - this.loadFile / this.totalFile * this.diameterStretch;
    }
  }

  hidePayProcess() {
    if (this.totalFile == this.totalFile) {
      this.toggleHide = false;
    } else {
      this.toggleHide = !this.toggleHide;
    }
  }

  menuOpened() {
    this.loadPageBuilder();
  }

  sideMenuEnable(value): any {
    this.sideEnable = value.sideMenu;
    this.swipeEnabled = value.swipeMenu;
  }

  getUserAccessGroup(userId: number) {
    this.accessmanagementapi.getUserAccessGroup(userId)
      .subscribe((result) => {
        return result;
      });
  }

  openBuilderPage(sfpage) {
    sfpage.builderStatus = true;
    sfpage.staticPage = false;
    this.openPage(sfpage);
  }

  openBuilderStaticPage(sfpage) {
    sfpage.builderStatus = true;
    sfpage.staticPage = true;
    this.openPage(sfpage);
  }

  /**
   * Load PageBuilder
   */
  loadPageBuilder() {
    this.menuRepository.getMenu()
      .subscribe(
        (menu) => {
          if (menu) {
            this.builderMenus = menu;
            this.events.publish('user:pagebuilder', this.builderMenus);
          }
        }, (error) => {
          if (error == 'logout') {
            this.gotoLogout();
          }
        }
      );
  }

  /**
   * Hide Splash screen custom
   */
  hideSplashScreen() {
    setTimeout(() => {
      if (document.getElementById("splash-screen") != null) {
        document.getElementById("splash-screen").remove();
      }

      if (document.getElementById("footer-splash") != null) {
        document.getElementById("footer-splash").remove();
      }
    }, 500)
  }

  /**
   * Handle Deeplink Apps
   */
  loadDeepLink() {
    const deeplink = this.deeplinks.route({
      // '/:accountid/:companycode': "Login2Page",
      '/recruitment/:key': "Login2Page",
      '/forgot-password': "ForgotPassPage",
      '/resetpasswordv2/:company_code/:code/:date_request': "ForgotPass2Page",
      '/ppago/:username/:token': "LoginDeeplinkPage",
      '/recruitment-forgotpassword/:key': "ForgotPass2PageRecruitment",
      '/legacy/:key': "Login2Page",
      '/deeplink-sso/:token': "SsoDeeplinkPage",
      '/auto-login/:company/:username/:token': "LoginDeeplinkPage",
    }).subscribe((match) => {
      console.log('args', match.$args);
      console.log('route', match.$route);
      this.events.publish('deeplink:running');
      this.nav.setRoot(match.$route, match.$args);
    }, (nomatch) => {
      // nomatch.$link - the full link data
      console.log('no match', nomatch)
    }, () => {
      deeplink.unsubscribe();
    });
  }

  /**
   * Initialize Apps
   */
  async initializeApp() {
    this.hideSplashScreen();

    await this.platform.ready();
    /* initialize menu , pagebuilder, and other menu */
    this.initNewTheme();
    // this.chatSupportService.initZendesk();

    if (this.platform.is('cordova')) {
      // this.simProvider.checkSimCard();
      this.loadDeepLink();
      this.setIntervalCheckConnection();
      this.networkConnection();
      this.runPingerPingServer();
    }

    this.runStatusSending();
    this.initScreenOrientation();
    this.getVersionApp();
    this.initKeyboard();
    // this.setLocation();
    this.checkOfflineModeAttData();
    this.checkOfflineModeActRecordData();
    this.initBackButtonDevice();
    this.initPlatformPause();
    this.initPlatformResume();
    this.googleAnalyticsAuth();
  }

  /**
   * Get Version Number and Version Code App
   */
  async getVersionApp() {
    if (this.platform.is('cordova')) {
      this.versionNumber = await this.appVersion.getVersionNumber();
      this.versionCode = await this.appVersion.getVersionCode();
    }
  }

  /**
   * Initialize native keyboard
   */
  initKeyboard() {
    if (this.platform.is('cordova')) {
      this.keyboard.onKeyboardShow().subscribe(() => {
        this.showKeyboard = true;
      })

      this.keyboard.onKeyboardHide().subscribe(() => {
        this.showKeyboard = false;
      })
    }
  }

  /**
   * Initialize platform on resume
   */
  initPlatformResume() {
    this.platform.resume.subscribe(async () => {
      this.itervalTotalSuccessOnline = 0;
      this.runPingGoogleServer();
      this.checkOfflineModeAttData();
      this.checkOfflineModeActRecordData();
      this.setIntervalCheckConnection();
      this.defineEvents();
      this.getPollingResume();
      this.reStartBackgroundTracking();
      this.loadBirthday = false;
      await this.authenticationBloc.loadAuth();
      this.loadVersionApps();
      console.log('TCL: Platform Resume');
      this.initLocalTime();
    });
  }

  /**
   * Initialize platform on pause
   */
  initPlatformPause() {
    this.platform.pause.subscribe(() => {
      for (let i = 0; i <= this.intervalConnection; i++) {
        clearInterval(i);
      }

      for (let i = 0; i <= this.intervalserver; i++) {
        clearInterval(i);
      }

      this.reStartBackgroundTracking();
      this.unsubcribeEvents();
      console.log('TCL: Platform Pause');
    });
  }

  /**
   * Initialize Screen Orientation on mobile device
   */
  initScreenOrientation() {
    if (this.platform.is('cordova')) {
      this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
    }

    if (this.platform.is('cordova') && (
      this.platform.is('tablet') || this.platform.is('phablet'))) {
      this.screenOrientation.unlock();
    }

    setTimeout(() => {
      if (this.platform.is('cordova') && (this.platform.is('tablet') || this.platform.is('phablet'))) {
        this.screenOrientation.unlock();
      }
    }, 3000)

    setTimeout(() => {
      if (this.platform.is('cordova') && (this.platform.is('tablet') || this.platform.is('phablet'))) {
        this.screenOrientation.unlock();
      }
    }, 5000)

    setTimeout(() => {
      if (this.platform.is('cordova') && (this.platform.is('tablet') || this.platform.is('phablet'))) {
        this.screenOrientation.unlock();
      }
    }, 10000)
  }

  /**
   * Check Network Connection
   */
  networkConnection() {
    this.network.onDisconnect().subscribe((data) => {
      console.log('disconect network', data)
      this.countOnConnect = 0;
    })

    this.network.onConnect().subscribe((data) => {
      console.log('network online', data)
      this.isOnline = true;

      /** handle double trigger run function network on connect */
      this.countOnConnect++;
      if (this.countOnConnect == 1) {
        setTimeout(() => this.saveAttendanceCheck(false), 2000)
      }

      this.events.publish('login:isOnline', { isOnline: true });
      this.events.publish("OFFLINEMODE:ONLINEWIFI", "");
      this.runPingGoogleServer();
      //ga track event
      this.analyticsProvider.trackEvent(EventNameAnalytics.NETWORK, 'connected');
    });
  }

  /**
   * Back button device listener
   */
  initBackButtonDevice() {
    // implement back button action listener
    this.platform.registerBackButtonAction(async () => {
      // Get current nav
      const nav = this.app.getRootNav();

      console.log('nav', nav);
      console.log('this.ionicApp', this.ionicApp);
      // Get overlay like modal/popover
      const activeLoading = this.ionicApp._loadingPortal.getActive();
      const activePortal = this.ionicApp._modalPortal.getActive() || this.ionicApp._overlayPortal.getActive() || null;

      /** if this page is modal or popover, so dismiss it */
      if (!activeLoading && activePortal) {
        activePortal.dismiss();
      }
      /** if this page can go back, so run nav pop */
      else if (!activeLoading && nav.canGoBack()) {
        nav.pop();
      }
      /** if this root page, so alert for exit app */
      else {
        if (!activeLoading && !this.appGuideProviders.isRunTourGuide) {
          const confirm = await this.alertService.confirmMola(Messages.EXIT_CONFIRM, 'Cancel', 'Ok');
          /** close application */
          if (confirm) this.appMinimize.minimize();
        }
      }
    }, 1);

  }

  /**
   * Init New Theme
   */
  async initNewTheme() {
    this.menuService.newHome = true;
  }

  /**
   * Init menu page builder
   */
  async initMenu() {

    this.storage.get('SFGoAuth').then(results => {
      let SFGoAuth = JSON.parse(results);
      if (SFGoAuth) {
        if (Object.keys(SFGoAuth).length > 1) {
          if (!(Object.keys(SFGoAuth).length == 0 && SFGoAuth.constructor == Object)) {
            this.loadPageBuilder();
          }
        }
      }
    });
  }

  /**
   * Set interval for check connection
   */
  setIntervalCheckConnection() {
    try {
      this.storage.get('SFGoStorage').then((SFGoStorage) => {
        if (SFGoStorage != null && SFGoStorage != undefined) {
          if (!JSON.parse(SFGoStorage).storedPrelogin.IST.toLowerCase().includes('-intranet')) {
            this.intervalConnection = setInterval(() => {
              this.checkConnection();
            }, 1000);
          }
        }
        else {
          this.intervalConnection = setInterval(() => {
            this.checkConnection();
          }, 1000);
        }
      }).catch((error) => {
        this.intervalConnection = setInterval(() => {
          this.checkConnection();
        }, 1000);
      })

    } catch (error) {
    }
  }

  /**
  * Check Geo
  */
  setLocation(): any {
    // try {
    //   if (!this.platform.is('cordova')) {
    //     this.geolocation.getCurrentPosition({
    //       maximumAge: 0,
    //       timeout: 1,
    //       enableHighAccuracy: true
    //     }).then((position) => {
    //     }).catch((error) => {
    //     });
    //   }
    // } catch (error) {
    //   console.log('set location error', error)
    // }
  }

  /**
   * Open page destination
   * @param menu
   */
  async openPage(menu) {
    // validasi double click
    if (this.isClickMenu) return;

    try {
      this.content.scrollToTop();
    } catch (error) { }

    this.isClickMenu = true;

    if (menu.pageBuilderId != null) {
      // load page from page builder
      this.storage.ready().then(async () => {
        this.storage.get('SFGoAuth').then(async (hasil) => {
          if (hasil != null && hasil != undefined) {
            let SFGoAuth = JSON.parse(hasil);
            let pageBuilderPages = await this.storage.get("pageBuilderPages");
            try {
              pageBuilderPages = JSON.parse(pageBuilderPages);
            } catch (e) {
              pageBuilderPages = pageBuilderPages;
            }

            let version = await this.storage.get("pageBuilderVersion");
            version = JSON.parse(version);

            try {
              version = JSON.parse(version);
            } catch (e) {
              version = version;
            }

            if (menu && menu.pageCode) {
              const getPageByCode = await this.featurePageServiceProvider.getPageFeatureByCode(menu.pageCode);
              menu.pageBuilderId = getPageByCode && getPageByCode.pageId ? getPageByCode.pageId : menu.pageBuilderId;
            }

            let navParam = {
              pageId: menu.pageBuilderId,
              pageTitle: 'Loading...',
              pageType: null,
              pageSchema: null,
              pageFile: null,
              pageParam: [],
              pageIsSub: false,
              userId: SFGoAuth.userId,
              static: menu.pageStatic,
              cacheDuration: null,
              cacheStart: null,
              typeMenu: menu.typeMenu,
              version: null,
            }

            this._pageBuilderGlobal.removeStorage();
            if (menu.externalUrl !== null) {
              try {
                let url_string = menu.externalUrl;
                let paramString = url_string.split('?')[1];
                let queryString = new URLSearchParams(paramString);
                for (let pair of queryString.entries()) {
                  menu.externalUrl = this.updateQueryStringParameter(menu.externalUrl, pair[0], SFGoAuth[pair[0]]);
                }
              } catch (error) {
                console.log(error);
              }
              if (!this.platform.is('cordova')) {
                menu.target = '_system';
              }
              this.openMenuInAppBrowser(menu.externalUrl, menu.target)
            } else {
              if (menu.typeMenu == 'push') {
                // handle webview
                window.parent.postMessage({ viewDidLoad: true }, '*');
                await this.nav.push('InitPageBuilder', navParam);
              } else {
                await this.nav.setRoot('InitPageBuilder', navParam);
              }
            }
            this.content.scrollToTop();
          }
        });
      });
    } else {
      // load static page
      const staticPage = menu.pageStatic;

      if (menu.menuId) {
        if (menu.params) {
          menu.params = Object.assign({}, menu.params, { 'menuId': menu.menuId });
        } else {
          menu.params = Object.assign({}, { 'menuId': menu.menuId });
        }
      }

      if (menu.pageStatic == 'FthermalIntroductionPage') {
        const isWelcome = this.appPreferences.getWelcomeThermal();
        if (isWelcome) {
          menu.pageStatic = "FthermalDashboardPage";
        }
        menu.params.typeMenu = menu.typeMenu;
      }

      if (staticPage == 'Home2Page' || staticPage == 'HomePage' || staticPage == 'TabsPage') {
        if (this.isSF7) {
          await this.nav.setRoot('HomePage');
        } else {
          await this.nav.setRoot(staticPage, menu.params);
        }
        console.log('BUKA PERTAMA', staticPage);
        // this.initHomeMobile();
      } else {
        if (menu.typeMenu == 'push') {
          await this.nav.push(menu.pageStatic, menu.params);
        } else {
          await this.nav.setRoot(menu.pageStatic, menu.params);
        }
      }

      if (menu.onDidDismiss) {
        this.nav.getActive().onDidDismiss((data) => {
          this.events.publish(menu.pageStatic, data);
        });
      }

      if (staticPage == 'Payroll2Page') {
        this.analyticsProvider.trackEvent(EventNameAnalytics.OPEN_MENU, 'Go To ' + menu.pageStatic + ' By Side Menu')
      }
    }

    this.isClickMenu = false;
  }

  openMenuInAppBrowser(url: string, target: string = '_system') {
    if (this.platform.is('cordova')) {
      const defaultOptions: InAppBrowserOptions =
        this.platform.is('android') ? {
          zoom: "no",
          hidden: "no",
          clearcache: "yes",
          clearsessioncache: "yes",
          hardwareback: "yes",
          toolbar: "no",
          hideurlbar: 'yes',
          hidenavigationbuttons: 'yes',
          toolbarcolor: '#f77a00',
          closebuttoncaption: 'Back',
          closebuttoncolor: 'white',
          beforeload: 'get',
          allowInlineMediaPlayback: 'yes'
        } : {
          hidden: "no",
          clearcache: "yes",
          clearsessioncache: "yes",
          toolbar: "yes",
          hideurlbar: 'yes',
          hidenavigationbuttons: 'yes',
          toolbarcolor: '#f77a00',
          closebuttoncaption: 'Back',
          closebuttoncolor: 'white',
          toolbartranslucent: 'yes',
          toolbarposition: 'top'
        };
      const browser = this.inAppBrowser.create(url, target, defaultOptions);
      browser.show();
    } else {
      const win = window.open(url);
      win.focus();
    }
  }


  /**
   * Logout Apps
   */
  async gotoLogout() {
    const loading = this.loadingCtrl.create({});
    loading.present();
    // handle karena kena cors terus saat check koneksi server
    // const isTheServiceDead = this.platform.is('cordova') ? await this.initializeBloc.isTheServiceDead() : false;
    const isTheServiceDead = false;

    if (!isTheServiceDead) {
      this.isLarge = false;
      this.content.scrollToTop();

      try {
        const SFGoAuth = await this.sfgoAuthService.getAuthorization();
        if (SFGoAuth.menu['tracking']) {
          await this.backgroundGeolocationBloc.checkIsRunning();
          const isPositionTracker = await this.backgroundGeolocationBloc.checkStatus();
          const flexibleTracking = this.SFGoAuth.companySetting.flexibleTracking || false;

          if (isPositionTracker && !flexibleTracking) {
            loading.dismiss();
            await this.alertService.createMola(this.translate.instant('You cannot log out because tracking is still active'));
          } else {
            await this.initializeBloc.gotoLogout();
            this.gotoLoginPage(loading);
          }

        } else {
          await this.initializeBloc.gotoLogout();
          this.gotoLoginPage(loading);
        }
      }
      catch (error) {
        console.log(error);
        this.gotoLoginPage(loading);
      }
    }
    else {
      loading.dismiss();
      this.runPingerPingServer();
    }
  }

  async gotoLogoutRecruitment() {
    const loading = this.loadingCtrl.create({});
    loading.present();
    await this.stopTracking();
    // const isTheServiceDead = this.platform.is('cordova') ? await this.initializeBloc.isTheServiceDead() : false;
    const isTheServiceDead = false;

    if (!isTheServiceDead) {
      this.isLarge = false;
      this.content.scrollToTop();
      this.clearStorage();

      try {
        await this.initializeBloc.gotoLogoutRecruitment();
        this.gotoLoginPage(loading);
      }
      catch (error) {
        this.gotoLoginPage(loading);
      }
    }
    else {
      loading.dismiss();
      this.runPingerPingServer();
    }
  }

  /**
   * Redirect to login page
   * @param loading
   */
  async gotoLoginPage(loading: any) {
    this.clearStorage();
    this.isLogout = false;
    this.isLoadMenu = false;
    this.builderMenus = null;
    this.menuRepository.clear();
    this.auth.clear();
    this.authBudget.clear();
    this.fcmServiceProvider.deleteUser();
    this.localNotifications.cancelAll();

    loading.dismiss();
    if (!this.platform.is('cordova')) this.socketIoClientProvider.timerOff();
    const multipleAccount = await this.appPreferences.getMultipleAccount();
    if (multipleAccount && multipleAccount.length) {
      this.nav.setRoot("SwitchAccountPage");
    } else {
      this.nav.setRoot("Login2Page");
    }

  }

  /**
   * Clear local storage
   */
  async clearStorage() {
    const clearStorage = await this.initializeBloc.clearStorage();
    if (clearStorage.SFGoStorage) {
      this.events.publish('login:updateIst', { SFGoStorage: clearStorage.SFGoStorage });
    }
  }

  gotoAppVersion(): void {
    this.nav.push('AppVersionPage', { statusUpdate: this.appUpdate });
    this.content.scrollToTop();
  }

  gotoSetting(): void {
    this.nav.push('SettingPage');
    this.content.scrollToTop();
  }

  gotoProfile() {
    this.nav.push('ProfileHomePage');
  }

  /**
   * Get User data
   * @param fromLogin
   */
  async loadPersonal(fromLogin) {
    this.loadPersonalNew(fromLogin)
  }

  /**
   * Get user data with nest api
   * @param fromLogin
   */
  async loadPersonalNew(fromLogin) {
    this.platform.ready().then(() => {
      this.storage.get('SFGoAuth').then(async (hasil) => {
        let data_used = hasil != null ? hasil : fromLogin;
        const LBpath = JSON.parse(data_used).path;

        this.companyphotopath = JSON.parse(data_used).companyphotopath || null;
        this.isSF6 = (JSON.parse(data_used).isSF6 == 1) ? true : false;
        if (LBpath !== '' && LBpath !== undefined && LBpath != null) {
          LoopBackConfig.setBaseURL(LBpath);
        } else {
          LoopBackConfig.setBaseURL(LoopBackConfig.getDefaultPath());
        }

        const personal = JSON.parse(data_used);

        try {
          if (personal.companyCode !== '' && personal.fullname !== '') {
            this.dataEmployee = personal;
            try {
              this.storagePathProvider.getStorageProfile()
                .then(val => {
                  this.empphotopath = encodeURI(val.urlDownload + this.dataEmployee.photo);
                });

              this.storage.get('SFGoAuth')
                .then(async (result) => {
                  let authStorage = JSON.parse(result);
                  authStorage.photo = this.dataEmployee.photo;
                  this.storage.set('SFGoAuth', JSON.stringify(authStorage))
                })

            } catch (err) {
              this.empphotopath = 'assets/images/bg-login-intro.png';
            }
            this.loadMyBirthday();
          } else {
            this.events.publish('user:goToHomePage', '')
          }
        } catch (error) {
          console.log(error);
        }


      }, error => {
        this.errorAlert('Storage Error', '')
      });
    });
  }

  /**
   * Get userdata with loopback api
   * @param fromLogin
   */
  async loadPersonalOld(fromLogin) {
    const gopathNew = await this.sfgoAuthService.isGopathNew();
    this.platform.ready().then(() => {
      this.storage.get('SFGoAuth').then(async (hasil) => {
        let data_used = hasil != null ? hasil : fromLogin;
        const LBpath = JSON.parse(data_used).path;

        this.companyphotopath = JSON.parse(data_used).companyphotopath || null;
        this.isSF6 = (JSON.parse(data_used).isSF6 == 1) ? true : false;

        if (LBpath !== '' && LBpath !== undefined && LBpath != null) {
          LoopBackConfig.setBaseURL(LBpath);
        } else {
          LoopBackConfig.setBaseURL(LoopBackConfig.getDefaultPath());
        }
        this.sunfishApi.getUserData().subscribe(result => {
          if (gopathNew) {
            this.sunfishNestApi.getPosition().subscribe();
          } else {
            this.sunfishApi.getPosition().subscribe();
          }
          if (result.result.Cmpany_code !== '' && result.result.fullname !== '') {
            this.dataEmployee = result.result;
            try {
              this.storagePathProvider.getStorageProfile()
                .then(val => {
                  this.empphotopath = encodeURI(val.urlDownload + this.dataEmployee.photo);
                });

              let authStorage = JSON.parse(data_used);
              authStorage.photo = this.dataEmployee.photo;
              console.log("Babay 2", authStorage);
              this.storage.set('SFGoAuth', JSON.stringify(authStorage))
            } catch (err) {
              this.empphotopath = 'assets/images/bg-login-intro.png';
            }
            this.loadMyBirthday();
          } else {
            this.events.publish('user:goToHomePage', '')
          }
        }, async (error) => {
          console.log(error);
        }
        );
      }, error => {
        this.errorAlert('Storage Error', '')
      });
    });
  }

  errorAlert(error_msg, error_handler): void {
    if (!this.showError) {
      this.showError = true;
      const confirm = this.alertCtrl.create({
        message: '<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" /><h6 style="color:#808080;">' + error_msg + '</h6>',
        buttons: [{
          text: 'OK',
          handler: () => {
            this.showError = false;
            error_handler;
          }
        }]
      });
      confirm.onDidDismiss(() => {
        this.showError = false;
      })
      confirm.present();
    }
  }

  /**
   * Switch company
   */
  // async changeCompany() {
  //   try {
  //     this.nav.push("ProgressbarPage", { isSwitchCompany: true });
  //     const switchCompany = await this.initializeBloc.switchCompany(this.selectCom);
  //     this.events.publish('company:switchdone');
  //     this.dataEmployee.position = switchCompany.companySelected;
  //     this.nav.setRoot('Home2Page');
  //   }
  //   catch (error) {
  //     this.nestApiProvider.responseError(error);
  //   }
  // }

  /**
   * Load Multiple company
   * @param fromLogin
   */
  async loadMultiCompany(fromLogin) {
    const loadMultiCompany = await this.initializeBloc.loadMultiCompany(fromLogin);
    this.selectCompany = loadMultiCompany.selectCompany;
    this.selectCom = loadMultiCompany.selectCom;

    // if (this.selectCompany[0].company_code == 'fabgroup') {
    //   const myCompany = await this.initializeBloc.myCompany(this.selectCompany[0].company_id);
    //   this.selectCompany[0].company_name = myCompany.companyName;
    // }
  }

  /**
   * Show ionic version
   * @param version
   */
  async showionicversion(version) {
    if (this.versionShow >= 7 && this.platform.is('cordova')) {

      const myMessage = 'Ionic ' + version + '<br />' +
        'App Package ' + await this.appVersion.getPackageName() + '<br />' +
        'App Version ' + await this.appVersion.getVersionNumber() + '<br />' +
        'App Code ' + await this.appVersion.getVersionCode() + '<br />' +
        'Cordova ' + this.device.cordova + '<br />' +
        'Model ' + this.device.model + '<br />' +
        'Platform ' + this.device.platform + '<br />' +
        'Uuid ' + this.device.uuid + '<br />' +
        'Version ' + this.device.version + '<br />' +
        'Manufacturer ' + this.device.manufacturer + '<br />' +
        'IsVirtual ' + this.device.isVirtual + '<br />' +
        'Serial ' + this.device.serial;


      const alert = this.alertCtrl.create({
        message: myMessage,
        buttons: [
          {
            text: 'Dismiss',
            handler: () => {
              this.versionShow = 1;
            }
          }]
      });
      alert.present();
    } else {
      this.versionShow += 1;
    }
  }

  funcTambahSize() {
    if (this.tambahSize == 'tutupSizeMenu') {
      this.tambahSize = 'bukaSizeMenu';
    } else {
      this.tambahSize = 'tutupSizeMenu';
    }
    this.loadPageBuilder();
  }

  /** Remove image in folder */
  async removeDirectory() {
    await this.platform.ready();
    if (this.platform.is('cordova')) {

      let attOffline = null;
      let activityOffline = null;

      try {
        await this.storage.ready();
        attOffline = await this.storage.get('SFGoAttendanceLog');
        activityOffline = await this.storage.get('SFGoActivityRecordingLog');
      } catch (error) {
        console.log('remove folder error', error);
      }

      /** remove folder activity record on internal directory system */
      if (!activityOffline) {
        this.permissionCheckProvider.removeDirectoryActivityRecord()
          .then((success) => {
            console.log('removeDirectoryActivity success', success);
          })
          .catch((error) => {
            console.log('removeDirectoryActivity error', error)
          });
      }

      /** remove folder attendance on internal directory system */
      if (!attOffline) {
        this.permissionCheckProvider.removeDirectoryAttendance()
          .then((success) => {
            console.log('removeDirectoryAttendance success', success);
          })
          .catch((error) => {
            console.log('removeDirectoryAttendance error', error)
          });
      }
    }
  }

  /**
   * **************************************************************************************************************
   * START MODULE OFFLINE MODE
   * **************************************************************************************************************
   */

  /**
   * *****************************************************
   * CHECK BEFORE SEND RECORD ATTENDANCE OFFLINE
   * *****************************************************
   */
  saveAttendanceCheck(button) {
    const alert = this.alertCtrl.create({
      message: '<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" /><h6 style="color:#808080;">To continue, please login first.</h6>',
      buttons: [
        {
          text: 'Dismiss',
          handler: () => {
          }
        }]
    });

    this.storage.get('SFGoAttendanceLog').then((attendance) => {
      console.log('attendance log check', attendance)
      if (attendance != null && attendance != undefined && attendance != "") {
        try {
          if (JSON.parse(attendance).length == 0) {
            this.saveActivityRecordCheck(true);
            return true;
          }
        } catch (error) {
          console.log('attendance log check error', attendance, error)
        }
        this.storage.get('SFGoAuth').then(hasil => {
          if (hasil != null && hasil != undefined) {
            let SFGoAuth = JSON.parse(hasil);
            if (Object.keys(SFGoAuth).length > 1) {
              this.runRecordAttendanceOffline();
            } else {
              if (button) {
                alert.present();
              }
            }
          } else {
            if (button) {
              alert.present();
            }
          }
        });
      } else {
        /**
         * RUN ACTIVITY RECORDING OFFLINE
         */
        this.saveActivityRecordCheck(true);
      }
    })
  }

  /**
   * *****************************************************
   * CHECK BEFORE SEND ACTIVITY RECORD OFFLINE
   * *****************************************************
   */
  saveActivityRecordCheck(button) {
    const alert = this.alertCtrl.create({
      message: '<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" /><h6 style="color:#808080;">To continue, please login first.</h6>',
      buttons: [
        {
          text: 'Dismiss',
          handler: () => {
          }
        }]
    });

    this.storage.get('SFGoActivityRecordingLog').then((activity) => {
      if (activity != null && activity != "" && activity != undefined) {
        activity = JSON.parse(activity);
        console.log('activity', activity);
        if (activity.length > 0) {
          this.storage.get('SFGoAuth').then(async (hasil) => {
            if (hasil != null) {
              let SFGoAuth = JSON.parse(hasil);
              if (Object.keys(SFGoAuth).length > 1) {
                if (!this.isSync) {
                  this.isSync = true;
                  this.events.publish('OFFLINEMODE:ISREMOVEACT', this.isSync);
                  const toast: Toast = this.toastCtrl.create({
                    message: this.translate.instant('Start to send Activity Recording'),
                    position: 'bottom',
                    showCloseButton: false,
                    closeButtonText: 'Close',
                    duration: 0,
                    cssClass: "toastAttendance"
                  });
                  await toast.present();
                  const itemsActivity = [];
                  const total = {
                    record: activity.length,
                    success: 0,
                    error: 0
                  };
                  let removeIndex = 0;

                  this.analyticsProvider.trackEvent(EventNameAnalytics.ACTIVITY_RECORDING_OFFLINE_START_TO_SEND, activity.length);
                  for (let i = 0; i < activity.length; i++) {
                    toast.setMessage(this.translate.instant(Messages.SENDING) + ' ' + (i + 1) + ' ' + this.translate.instant(Messages.OF) + ' ' + total.record + '.\n' + this.translate.instant(Messages.SENDING_ACTIVITY) + '...');
                    const result = await this.saveActivityRecord(activity[i], SFGoAuth);
                    if (result) {
                      total.success += 1;
                      this.events.publish('user:SFGoActivityLog', removeIndex);
                    } else {
                      total.error += 1;
                      itemsActivity.push(activity[i]);
                      removeIndex += 1;
                    }
                  }
                  if (itemsActivity.length == 0) {
                    this.storage.remove('SFGoActivityRecordingLog');
                  } else {
                    this.storage.set('SFGoActivityRecordingLog', JSON.stringify(itemsActivity));
                  }
                  toast.setMessage(this.translate.instant(Messages.SUCCESSFULLY_SEND) + ': ' + total.success + '.\n' + this.translate.instant(Messages.FAILED_TO_SEND) + ': ' + total.error + '.');
                  toast.setShowCloseButton(true);
                  this.isSync = false;
                  this.events.publish('OFFLINEMODE:ISREMOVEACT', this.isSync);
                  this.analyticsProvider.trackEvent(EventNameAnalytics.ACTIVITY_RECORDING_OFFLINE_FAILED_SEND, total.error);
                  this.analyticsProvider.trackEvent(EventNameAnalytics.ACTIVITY_RECORDING_OFFLINE_SUCCESS_SENT, total.success);
                  setTimeout(function () {
                    toast.dismiss();
                  }, 10000);
                }
              } else {
                if (button) {
                  await alert.present();
                }
              }
            } else {
              if (button) {
                await alert.present();
              }
            }
          });
        }
      }
    })
  }

  async saveActivityRecord(activity: any, SFGoAuth: any): Promise<boolean> {
    activity.picture.map(item => {
      if (item.base64) {
        item.data = item.base64;
      }
    })
    const sendPicture = await new Promise(async (resolve) => {
      const images = await this.activityRecordingBloc.uploadImage(activity.picture);
      if (!images.isSuccess) {
        resolve('upload failed');
      }
      resolve(images.fileName);
    });

    return await new Promise<boolean>(async (resolve) => {
      if (sendPicture === 'upload failed') {
        resolve(false);
        return false;
      }

      this.activityProvider.createActivity({
        empId: SFGoAuth.empId,
        companyid: SFGoAuth.companyId,
        companycode: SFGoAuth.companyCode,
        dateTime: activity.dateTime,
        taskDesc: activity.taskDesc,
        taskCode: '',
        startTime: activity.startTime,
        endTime: activity.endTime,
        location: activity.location,
        image: sendPicture,
        imageBase64: activity.picture,
        typeFields: [],
        attOn: 'offline'
      }).subscribe(
        _ => {
          resolve(true);
        },
        _ => {
          resolve(false);
        }
      )
    });
  }

  /**
   *  REWRITE RECORD ATTENDANCE
   */

  /**
   * Run Record attendance
   * @param dataRecord
   */
  async runRecordAttendance(dataRecord) {
    let toast = this.presentToast(this.translate.instant('Sending data') + '...');
    if (!this.isSync) {
      this.isSync = true;

      try {
        this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_START_TO_SEND);
      } catch (_) { }

      toast.present();
      await this.recordAttendance(dataRecord, 'online', toast);
    }
  }

  /**
   * Run Sync attendance offline
   */
  async runRecordAttendanceOffline() {
    if (!this.isSync) {
      this.isSync = true;

      try {
        this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_OFFLINE_START_TO_SEND);
      } catch (_) { }

      let totalProcess = {
        record: 0,
        success: 0,
        error: 0
      }

      const attendance = await this.storage.get('SFGoAttendanceLog');

      if (attendance != null && attendance != undefined && attendance != "") {
        let recordAttendanceList = [...JSON.parse(attendance)];
        totalProcess.record = recordAttendanceList.length;

        if (recordAttendanceList.length != 0) {
          let toast = this.presentToast(this.translate.instant('Sending data') + '...');
          toast.present();

          async.eachOfSeries([...JSON.parse(attendance)], async (item, index, callback) => {

            /** add flag this record is sending to server */
            const idx = recordAttendanceList.findIndex(i => i.id == item.id);
            if (idx != -1) {
              recordAttendanceList[idx].isRunning = true;
              this.updateStorageOffline(recordAttendanceList);
            }

            let offlineProcess = {
              recordAttendanceList: recordAttendanceList,
              index: index,
              totalProcess: totalProcess
            }

            totalProcess = await this.recordAttendance(item, 'offline', toast, offlineProcess);
            callback();
          })

        }
      } else {
        /**
         * RUN ACTIVITY RECORDING OFFLINE
         */
        this.saveActivityRecordCheck(true);
      }
    }
  }

  /**
   * Update attendance offline data in storage
   * @param recordAttendanceList
   */
  updateStorageOffline(recordAttendanceList) {
    this.storage.set('SFGoAttendanceLog', JSON.stringify(recordAttendanceList));
    this.events.publish('user:SFGoAttendanceLog', undefined);
  }

  /**
   * Record attendance execute
   * @param dataRecord
   * @param toast
   */
  async recordAttendance(dataRecord: ResponseAttendanceMachine, attOn: string = 'online', toast?: Toast, offlineProcess?: AttendanceOfflineData): Promise<any> {
    const auth = await this.appPreferences.getAuth();
    let picture = null;

    // stop process ketika user belum login
    if (!auth) {
      this.isSync = false;
      if (toast) toast.dismiss();
      return false;
    }

    if ((dataRecord.photoUrl != "" && dataRecord.photoUrl != null) || (dataRecord.imageBase64 != "" && dataRecord.imageBase64 != null)) {
      if (attOn == 'online') {
        // upload foto online attendance
        picture = await this.uploadPictureAttendance(dataRecord, attOn, toast);
      } else {
        // upload foto offline attendance
        picture = await this.uploadPictureAttendance(dataRecord, attOn, toast, offlineProcess.index, offlineProcess.totalProcess.record);
      }
      dataRecord.photo = picture;
    }

    try {
      if (auth && auth.companySetting && auth.companySetting.attendanceFace && picture) {
        const faceRecognition = await this.attendanceBloc.faceDetection(picture);
        dataRecord.faceRecognition.accuration = faceRecognition.accuracy || faceRecognition.accuration;
      }
    } catch (error) {
      console.log('error face recog offline', error);
    }

    // memformat bentuk data yang akan dikirim ke server
    const payload = this.payloadRecordAttendance(dataRecord, auth, picture, attOn);

    try {
      if (picture || dataRecord.photoUrl == "") {
        let result = null;

        // initialize toast progress sync online attendance
        if (attOn == 'online') toast.setMessage(this.translate.instant(Messages.SENDING_ATTENDANCE) + '...');
        // initialize toast progress sync offline attendance
        if (attOn == 'offline') toast.setMessage(this.translate.instant(Messages.SENDING) + ' ' + (offlineProcess.index + 1) + ' ' + this.translate.instant(Messages.OF) + ' ' + offlineProcess.totalProcess.record + ' data ');

        // send attendance ke server
        if (dataRecord.isbarcode) {
          // send attendance barcode
          result = await this.attendanceBloc.recordTimeBarcode(auth, payload.payloadBarcodeGD, payload.payloadBarcodeSF6);
        } else {
          // send attendance default
          result = await this.attendanceBloc.recordTime(auth, payload.payloadGD, payload.payloadSF6);
        }

        if (dataRecord.isbarcode && !result.success) {
          // handle online attendance ketika error send attendance barcode
          if (attOn == 'online') this.failedRecordAttendance(result, dataRecord, picture, attOn, toast);
          // handle update progress sync offline attendance
          if (attOn == 'offline') {
            offlineProcess.totalProcess = await this.updateProcessOfflineAttendance(
              offlineProcess.recordAttendanceList,
              'error',
              picture,
              dataRecord,
              offlineProcess.totalProcess,
              offlineProcess.index,
              toast,
              result);

            // handle semua error yang terjadi ketika send attendance
            await this.appPreferences.setErrorMessage(result);
          }
        }
        else if (!dataRecord.isbarcode && !result.success) {
          // handle data message dataInQue dan message dari server lainnya
          if (attOn == 'online') {
            this.successRecordAttendance(auth, result, dataRecord, toast);
            const toastWhite = await this.attendanceBloc.runTracker();
            if (toastWhite) this.dismissToast(toastWhite);
          }

          //  handle update progress sync offline attendance
          if (attOn == 'offline') {
            offlineProcess.totalProcess = await this.updateProcessOfflineAttendance(
              offlineProcess.recordAttendanceList,
              'error',
              picture,
              dataRecord,
              offlineProcess.totalProcess,
              offlineProcess.index,
              toast,
              result);

            // handle semua error yang terjadi ketika send attendance
            await this.appPreferences.setErrorMessage(result);
          }
        }
        else {
          // handle ketika success kirim attendance
          if (attOn == 'online') {
            this.successRecordAttendance(auth, result, dataRecord, toast);
            const toastWhite = await this.attendanceBloc.runTracker();
            if (toastWhite) this.dismissToast(toastWhite);
          }

          //  handle update progress sync offline attendance
          if (attOn == 'offline') offlineProcess.totalProcess = await this.updateProcessOfflineAttendance(offlineProcess.recordAttendanceList, 'success', picture, dataRecord, offlineProcess.totalProcess, offlineProcess.index, toast);
        }
      }
      else {
        // handle failed send foto attendance
        if (attOn == 'online') this.failedRecordAttendance(Messages.FAILED_SENDING_PHOTO, dataRecord, picture, attOn, toast);
        // handle update progress sync offline attendance
        if (attOn == 'offline') offlineProcess.totalProcess = await this.updateProcessOfflineAttendance(offlineProcess.recordAttendanceList, 'error', picture, dataRecord, offlineProcess.totalProcess, offlineProcess.index, toast);
      }
    }
    catch (error) {
      // handle semua error yang terjadi ketika send attendance
      await this.appPreferences.setErrorMessage(error);
      if (attOn == 'online') this.failedRecordAttendance(error, dataRecord, picture, attOn, toast);
      // handle update progress sync offline attendance
      if (attOn == 'offline') offlineProcess.totalProcess = await this.updateProcessOfflineAttendance(offlineProcess.recordAttendanceList, 'error', picture, dataRecord, offlineProcess.totalProcess, offlineProcess.index, toast, error);
    }

    return (attOn == 'online') ? 'done' : offlineProcess.totalProcess;
  }

  /**
   * Save attendance successfully
   * @param auth
   * @param result
   * @param dataRecord
   * @param toast
   */
  async successRecordAttendance(auth: GDAuthInterface, result: any, dataRecord: any, toast: Toast) {
    this.isSync = false;
    console.log('dataRecord', dataRecord);
    /** publish event record attendance is successfully */
    this.events.publish('attendance:success-record-attendance', { response: result, record: dataRecord });

    /** present toast message successfully attendance */
    let message: string = this.attendanceBloc.messageSuccessAttendance(auth, result, dataRecord)

    toast.setMessage(this.translate.instant(message));
    toast.setShowCloseButton(true);

    /** present local notification successfully attendance */
    this.globalService.presentLocalNotification(2, Messages.ATTENDANCE_RECORD, message);
    /** remove data attendance temporary from storage */
    await this.attendanceBloc.attendanceRemoveTempStorage(dataRecord);

    try {
      // hapus storage todayform wlc
      if (auth.companySetting && auth.companySetting.wlc) {
        await this.appPreferences.removeGreatdayStorage(Preference.GDAttendanceTodayForm);
      }
    } catch (_) { }

    setTimeout(() => {
      this.events.publish('attendance:checkofflinedata', true);
    }, 1500);
  }

  /**
   * Save to offline data and show message faild save attendace
   * @param error
   * @param dataRecord
   * @param picture
   * @param toast
   */
  async failedRecordAttendance(error, dataRecord, picture, attOn: string = 'online', toast: Toast) {
    this.isSync = false;
    this.events.publish('attendance:sendtoaws', { request: dataRecord, response: error });
    this.events.publish('attendance:failed-record-attendance', { request: dataRecord, response: error });

    if (this.attendanceBloc && this.attendanceBloc.attendanceSetting && this.attendanceBloc.attendanceSetting.offlineMode) {
      this.saveToOfflineMode(error, dataRecord, picture, toast);
    }

    if (dataRecord.isbarcode) {
      this.failedRecordAttendanceBarcode(error, picture, toast);
    } else {
      this.failedRecordAttendanceDefault(dataRecord, picture, toast);
    }

    this.globalService.presentLocalNotification(1, Messages.ATTENDANCE_RECORD, this.attendanceBloc.messageFailedSendAttendance);
  }

  /**
   * Show error failed attendance except barcode
   */
  failedRecordAttendanceDefault(dataRecord, picture, toast) {
    if (picture || dataRecord.photoUrl == "") {
      toast.setMessage(this.attendanceBloc.messageFailedSendAttendance);
    }
    else {
      toast.setMessage(this.translate.instant(this.translate.instant(Messages.FAILED_SENDING_PHOTO)));
    }

    toast.setShowCloseButton(true);
  }

  /**
   * Show error failed attendance barcode
   * @param error
   * @param picture
   * @param toast
   */
  failedRecordAttendanceBarcode(error, picture, toast: Toast) {
    let message: string = this.attendanceBloc.messageFailedSendAttendance;
    try {
      message = this.attendanceBloc.nestApiProvider.nestResponseProvider.handleMsgError(error)
    } catch (error) {
    }

    if (picture) {
      const toastMsgError = this.presentToast(message);
      toastMsgError.present();
      toastMsgError.setShowCloseButton(true);
      toast.dismiss();

      toastMsgError.onDidDismiss(() => {
        toast = this.presentToast(this.attendanceBloc.messageFailedSendAttendance);
        toast.present();
        toast.setShowCloseButton(true);
      });
    }
    else {
      toast.setMessage(this.translate.instant(Messages.SENDING) + '.\n' + this.translate.instant(Messages.FAILED_SENDING_PHOTO) + '.');
      toast.setShowCloseButton(true);
    }
  }

  /**
   * updating process sync offline attendance data
   * @param recordAttendanceList
   * @param status
   * @param picture
   * @param dataRecord
   * @param totalProcess
   * @param index
   * @param toast
   * @param error
   */
  async updateProcessOfflineAttendance(recordAttendanceList: Array<any>, status: string, picture: any, dataRecord: any, totalProcess: { record: any, success: number, error: number }, index: any, toast: Toast, error?: any): Promise<{ record: any, success: number, error: number }> {
    const counter = await this.counterAttendanceOffline(recordAttendanceList, status, picture, dataRecord, totalProcess, index, error, toast);
    totalProcess = counter.totalProcess;

    if (totalProcess.record == (index + 1)) {
      this.syncAttendanceOfflineFinish(totalProcess, toast);
    }

    return { record: totalProcess.record, success: totalProcess.success, error: totalProcess.error };
  }

  /**
   * Count total progress sync attendance offline that success or error
   * @param recordAttendanceList
   * @param status
   * @param picture
   * @param dataRecord
   * @param totalProcess
   * @param index
   * @param error
   * @param toast
   */
  async counterAttendanceOffline(recordAttendanceList: Array<any>, status: string, picture: any, dataRecord: any, totalProcess: { record: number, success: number, error: number }, index: any, error: any, toast: Toast): Promise<{ totalProcess: { record: number, success: number, error: number }, recordAttendanceList: Array<any> }> {
    /** get index of record */
    const idx = recordAttendanceList.findIndex(i => i.id == dataRecord.id);
    if (status == 'success') {
      // handle success attendance
      if (dataRecord.isbarcode) {
        toast.setMessage(this.translate.instant(Messages.SENDING) + ' ' + (index + 1) + ' ' + this.translate.instant(Messages.OF) + ' ' + totalProcess.record + ' data (barcode).');
      }
      else {
        toast.setMessage(this.translate.instant(Messages.SENDING) + ' ' + (index + 1) + ' ' + this.translate.instant(Messages.OF) + ' ' + totalProcess.record + ' data');
      }

      totalProcess.success = totalProcess.success += 1;
      recordAttendanceList.splice(idx, 1);
      this.updateStorageOffline(recordAttendanceList);
    } else {
      // handle error attendance
      recordAttendanceList[idx].photo = picture;
      recordAttendanceList[idx].status = false;
      recordAttendanceList[idx].isRunning = false;

      let messageError: string = error;
      let fullError: string = error;
      try {
        const getErrorMessage = await this.appPreferences.getErrorMessage();
        fullError = JSON.stringify(getErrorMessage);
        messageError = this.nestResponse.handleMsgError(getErrorMessage);
        if (error == Messages.FAILED_SENDING_PHOTO) {
          messageError = `${Messages.FAILED_SENDING_PHOTO}-${messageError}`;
        }
      } catch (error) { }

      recordAttendanceList[idx].message = `${messageError} | ${fullError}`;
      if (!dataRecord.isbarcode) {
        recordAttendanceList[idx].message = `${messageError} | ${fullError}`;
      }

      totalProcess.error = totalProcess.error += 1;
      this.updateStorageOffline(recordAttendanceList);
      this.events.publish('attendance:sendtoaws', { request: dataRecord, response: error });
    }

    return { totalProcess: totalProcess, recordAttendanceList: recordAttendanceList }
  }

  /**
   * Show notification the attendance offline finished sync
   * @param totalProcess
   * @param toast
   */
  async syncAttendanceOfflineFinish(totalProcess: { record: number, success: number, error: number }, toast: Toast) {
    this.isSync = false;

    /** show message */
    toast.setMessage(this.translate.instant(Messages.SUCCESSFULLY_SEND) + ': ' + totalProcess.success + '.\n\n\n' + this.translate.instant(Messages.FAILED_TO_SEND) + ': ' + totalProcess.error + '.');
    toast.setShowCloseButton(true);
    setTimeout(function () {
      toast.dismiss();
    }, 10000);

    /** show local notification */
    let msg = this.translate.instant(Messages.SUCCESSFULLY_SEND) + ': ' + totalProcess.success + '. ' + this.translate.instant(Messages.FAILED_TO_SEND) + ': ' + totalProcess.error + '. '
    this.globalService.presentLocalNotification(11, Messages.OFFLINE_ATTENDANCE, msg);

    /** publish event sync successfully and remove attendance data from storage */
    if (totalProcess.success == totalProcess.record) {
      this.events.publish('user:SFGoAttendanceLog', undefined);
      this.events.publish('attendance:success-record-attendance', true);
      await this.storage.remove('SFGoAttendanceLog');
      setTimeout(() => {
        this.events.publish('attendance:checkofflinedata', true);
      }, 1500);
    }
    else {
      this.events.publish('user:SFGoAttendanceLog', undefined);
    }

    /** show snackbar data offline in home page */
    if (totalProcess.error > 0) {
      this.events.publish('attendance:checkofflinedata', true);
    }

    /** Run check activity record data */
    this.saveActivityRecordCheck(true);
  }

  /**
   * Upload picture attendance
   * @param dataRecord
   * @param toast
   */
  async uploadPictureAttendance(dataRecord: ResponseAttendanceMachine, attOn, toast: Toast, index?: number, totalRecord?: number) {
    return new Promise<string>(async (resolve) => {
      let picture: string = dataRecord.photo;
      let notUploadedYet = true;

      // check photo sudah di upload atau belum
      if (picture) {
        if (picture.lastIndexOf('/') != -1) {
          notUploadedYet = true;
        }
        else {
          notUploadedYet = false;
        }
      }

      if (notUploadedYet) {
        if (attOn == 'online') toast.setMessage(this.translate.instant(Messages.UPLOADING_PHOTO) + '...');
        if (attOn == 'offline') toast.setMessage(this.translate.instant(Messages.SENDING) + ' ' + (index + 1) + ' ' + this.translate.instant(Messages.OF) + ' ' + totalRecord + ' ' + this.translate.instant('Photo'));

        picture = await this.attendanceBloc.uploadPhoto(dataRecord);
        dataRecord.photo = picture;
      }

      resolve(picture);
    })
  }

  /**
   * Define payload record attendance
   * @param data
   * @param auth
   * @param picture
   * @param attOn
   */
  payloadRecordAttendance(data: ResponseAttendanceMachine, auth: GDAuthInterface, picture: string, attOn: string = 'online') {
    const payloadSF6: RequestRecordTimeSF6Dto = {
      empid: auth.empId,
      companyId: auth.accId || auth.companyId,
      datetime: data.datetime,
      geolocation: data.geolocation,
      photo: picture,
      attOn: attOn,
      setBasePhoto: data.setBasePhoto || false,
      attBreak: data.attBreak || null,
      address: data.geolocation && data.geolocation.address ? data.geolocation.address : null,
      skipErrorLocation: data.skipErrorLocation || false,
      versionApps: data.versionApps,
      gmtVersion: Intl.DateTimeFormat().resolvedOptions().timeZone,
      faceRecognition: data.faceRecognition || null
    };

    const payloadGD: RequestRecordTimeGdDto = {
      empId: auth.empId,
      time: data.datetime,
      geolocation: data.geolocation,
      picture: picture,
      flagButton: data.flagButton || "",
      attOn: attOn,
      setBasePhoto: data.setBasePhoto || false,
      attBreak: data.attBreak || null,
      breakNo: data.breakNo || null,
      address: data.geolocation && data.geolocation.address ? data.geolocation.address : null,
      skipErrorLocation: data.skipErrorLocation || false,
      versionApps: data.versionApps,
      gmtVersion: Intl.DateTimeFormat().resolvedOptions().timeZone,
      faceRecognition: data.faceRecognition || null
    }

    const payloadBarcodeSF6: RequestRecordTimeBarcodeSF6Dto = {
      companyId: auth.accId || auth.companyId,
      empid: auth.empId,
      barcode: data && data.barcode ? data.barcode : null,
      datetime: data.datetime,
      photo: picture,
      geolocation: data.geolocation,
      attOn: attOn,
      attBreak: data.attBreak || null,
      address: data.geolocation && data.geolocation.address ? data.geolocation.address : null,
      skipErrorLocation: data.skipErrorLocation || false,
      versionApps: data.versionApps,
      gmtVersion: Intl.DateTimeFormat().resolvedOptions().timeZone
    }

    const payloadBarcodeGD: RequestRecordTimeBarcodeGdDto = {
      empId: auth.empId,
      barcode: data.barcode ? data.barcode : null,
      time: data.datetime,
      geolocation: data.geolocation,
      picture: picture,
      attOn: attOn,
      flagButton: data.flagButton || "",
      attBreak: data.attBreak || null,
      address: data.geolocation && data.geolocation.address ? data.geolocation.address : null,
      skipErrorLocation: data.skipErrorLocation || false,
      versionApps: data.versionApps,
      gmtVersion: Intl.DateTimeFormat().resolvedOptions().timeZone
    }

    try {
      if (auth.companySetting && auth.companySetting.wlc) {
        payloadSF6.wlc = data.wlc;
        payloadGD.wlc = data.wlc;
        payloadBarcodeSF6.wlc = data.wlc;
        payloadBarcodeGD.wlc = data.wlc;
      }
    } catch (error) {
      console.log('error wlc', error);
    }

    return { payloadGD: payloadGD, payloadSF6: payloadSF6, payloadBarcodeGD: payloadBarcodeGD, payloadBarcodeSF6: payloadBarcodeSF6 }
  }

  /**
   * Save to storage (offline data)
   * @param error
   * @param recordData
   * @param picture
   */
  async saveToOfflineMode(error: any, recordData: any, picture: string, toast: Toast) {
    let messageError: string = error;
    let fullError: string = error;
    let getErrorMessage: string = error;

    try {
      getErrorMessage = await this.appPreferences.getErrorMessage();
    } catch (_) { }

    try {

      try {
        fullError = JSON.stringify(getErrorMessage, Object.getOwnPropertyNames(getErrorMessage));
      } catch (error) {
        fullError = JSON.stringify(getErrorMessage);
      }

      messageError = this.nestResponse.handleMsgError(getErrorMessage);
      if (error == Messages.FAILED_SENDING_PHOTO) {
        messageError = `${Messages.FAILED_SENDING_PHOTO}-${messageError}`;
      }
    } catch (_) { }

    recordData.photo = picture;
    recordData.status = false;
    recordData.isRunning = false;
    recordData.attOn = "offline";
    recordData.message = `${messageError} | ${fullError}`;
    recordData.error = `${this.nestResponse.handleErrorList(getErrorMessage)} | ${fullError}`;

    const dataAttendance = await this.storage.get('SFGoAttendanceLog');
    if (dataAttendance != null && dataAttendance != undefined) {
      let data: Array<any> = JSON.parse(dataAttendance);

      /** remove temporary data */
      const idx = data.findIndex((item) => item.id == recordData.id);
      if (idx != -1) data.splice(idx, 1);

      /** replace data temporary attendance */
      data.push(recordData);
      this.storage.set('SFGoAttendanceLog', JSON.stringify(data));
    }
    else {
      let data = [];
      data.push(recordData);
      this.storage.set('SFGoAttendanceLog', JSON.stringify(data));
    }

    this.analyticsProvider.trackEvent(EventNameAnalytics.ATTENDANCE_OFFLINE_TOTAL, 'online');
    toast.onDidDismiss(() => {
      this.events.publish('attendance:checkofflinedata', true);
    })
  }


  presentToast(msg: string) {
    let params = {
      message: this.translate.instant(msg),
      position: 'bottom',
      showCloseButton: false,
      closeButtonText: this.translate.instant("Ok"),
      cssClass: "custom-toast",
      dismissOnPageChange: false
    }

    let toast = this.toastCtrl.create(params);

    return toast;
  }

  /**
   * *****************************************************
   * RUN PING ONLINE GOOGLE
   * *****************************************************
   * Dijalankan setiap 0.5 detik
   */
  runPingerPing() {
    if (!this.runPing) {
      this.runPing = true;
      var image = new Image();
      var start = new Date().getTime();
      var timeout = setTimeout(() => {
        runImage(timeout);
      }, 1500);
      image.onload = () => {
        runLoad(timeout);
      };
      image.onerror = () => {
        runImage(timeout);
      };
      image.src = "https://www.google.co.id/images/branding/googlelogo/2x/googlelogo_color_120x44dp.png?" + (new Date().getTime()).toString(36).toLowerCase();
    }

    let runImage = (timeout) => {
      clearTimeout(timeout);
      var image = new Image();
      var timeout2 = setTimeout(() => {
        runError(timeout2);
      }, 1500);
      image.onload = () => {
        runLoad(timeout2);
      };
      image.onerror = () => {
        runError(timeout2);
      };
      image.src = "https://www.dataon.com/images/banner-cs-call.jpg?" + (new Date().getTime()).toString(36).toLowerCase();
    }

    let runLoad = (timeout) => {
      var end = new Date().getTime();
      this.runPing = false;
      this.itervalTotalSuccessOnline = 0;
      this.events.publish('OFFLINEMODE:CONNECTIONOK', true);
      this.isOnline = true;
      clearTimeout(timeout);

      if ((end - start) > 100) {
        if (this.showToast && !this.showKeyboard) {
          this.showToast = false;
          clearInterval(this.intervalgoogle);
          this.intervalgoogle = setInterval(() => {
            this.showToast = true;
          }, 1000 * 60 * 5);
        }
      }
    }

    let runError = (timeout2) => {
      this.runPing = false;
      if (this.itervalTotalSuccessOnline > 10) {
        this.runOfflineModeMenu();
        this.itervalTotalSuccessOnline = 0;
      }
      this.itervalTotalSuccessOnline += 1;
      this.events.publish('OFFLINEMODE:CONNECTIONOK', false);
      this.isOnline = false;
      clearTimeout(timeout2);
    }
  }

  checkConnection() {
    this.pinger.runPing("https://www.google.com", (err, data) => {
      if (err) {
        if (this.itervalTotalSuccessOnline > 3) {
          this.runOfflineModeMenu();
          this.itervalTotalSuccessOnline = 0;
        }
        this.itervalTotalSuccessOnline += 1;
        this.events.publish('OFFLINEMODE:CONNECTIONOK', false);
        this.isOnline = false;
      } else {
        this.itervalTotalSuccessOnline = 0;
        this.events.publish('OFFLINEMODE:CONNECTIONOK', true);
        this.isOnline = true;
        if (data > 500) {
          if (this.showToast && !this.showKeyboard) {
            this.showToast = false;
            clearInterval(this.intervalgoogle);
            this.intervalgoogle = setInterval(() => {
              this.showToast = true;
            }, 1000 * 60 * 5);
          }
        }
      }
    });
  }

  /**
   * *****************************************************
   * RUN PING ONLINE SERVER SFGO
   * *****************************************************
   * Dijalankan setiap 5 menit
   */
  runPingerPingServer() {
    try {
      // if (!this.runPingServer) {
      //   this.storage.get('SFGoStorage').then((SFGoStorage) => {
      //     if (SFGoStorage != null && SFGoStorage != undefined) {
      //       if (!JSON.parse(SFGoStorage).storedPrelogin.IST.toLowerCase().includes('-intranet')) {
      //         this.runPingServer = true;
      //         const storedPrelogin = JSON.parse(SFGoStorage).storedPrelogin;
      //         const url = (storedPrelogin.hasOwnProperty('GOPATHNEW')) ? storedPrelogin.GOPATHNEW : storedPrelogin.GOPATH;
      //         this.http.get(url).subscribe(_ => {
      //           this.runPingServer = false;
      //           this.isOnlineServer = true;
      //           this.events.publish('OFFLINEMODE:SERVEROK', true);
      //           clearInterval(this.intervalserver);
      //           this.intervalserver = setInterval(() => {
      //             this.runPingerPingServer();
      //           }, 1000 * 60 * 5);
      //         }, _ => {
      //           this.runPingServer = false;
      //           this.runOfflineModeMenu();
      //           this.isOnlineServer = false;
      //           this.events.publish('OFFLINEMODE:SERVEROK', false);
      //           clearInterval(this.intervalserver);
      //           this.intervalserver = setInterval(() => {
      //             this.runPingerPingServer();
      //           }, 3000);
      //         })
      //       }
      //     }
      //   })
      // }
    } catch (error) {
    }
  }

  /**
   * *****************************************************
   * SHOW MENU OFFLINE MODE
   * *****************************************************
   */
  runOfflineModeMenu() {
    if (!this.isOfflineMode && !this.isShowOfflineModeMenu && !this.isPagePreviewAttendance && !this.showError) {
      this.isOfflineMode = true;
      let message = "";
      console.log('masuk offline mode menu fuct')
      if (this.isOnline && !this.isOnlineServer) {
        message = this.translate.instant(Messages.SERVER_ERROR_DESC);
      } else {
        message = this.translate.instant(Messages.NO_INTERNET_CONNECTION);
      }

      let alert = this.alertCtrl.create({
        message: `<img src="assets/images/sf-mola-mola.svg" width="40%" height="40%" /><h6 style="color:#808080;">` + message + `</h6>`,
        enableBackdropDismiss: false,
        buttons: [{
          text: 'DISMISS',
          handler: () => {
            var params = {
              isOnline: this.isOnline,
              isOnlineServer: this.isOnlineServer
            };
            if ((!this.isOnline || !this.isOnlineServer)) {
              this.openOfflinePage(params);
            }
          }
        }]
      });

      alert.onDidDismiss(() => {
        this.isOfflineMode = false;
      })
      alert.present();
    }
  }

  async openOfflinePage(params) {
    const setting = await this.attendanceBloc.getAttendanceSetting();
    console.log('company setting', setting);
    if (setting.offlineMode) {
      this.nav.setRoot('OfflineModeIndexPage', params).then(() => {
        this.isOfflineMode = false;
      });
    }
  }

  /**
   * *****************************************************
   * RUN SCHEDULE MULTIPLE NOTIFICATIONS
   * *****************************************************
   */
  checkOfflineModeAttData(): any {
    this.storage.get('SFGoAttendanceLog').then((attendance) => {
      if (attendance != null && attendance != undefined) {
        if (JSON.parse(attendance).length != 0) {
          let msg = this.translate.instant(Messages.THEREARE) + ' ' + JSON.parse(attendance).length + ' ' + this.translate.instant(Messages.NOTIF_SYNC_OFFLINE)
          this.globalService.presentLocalNotification(10, Messages.OFFLINE_ATTENDANCE, msg);
        }
      }
    });
  }

  checkOfflineModeActRecordData(): any {
    this.storage.get('SFGoActivityRecordingLog').then((activity) => {
      if (activity != null) {
        if (JSON.parse(activity).length != 0) {
          let msg = this.translate.instant(Messages.THEREARE) + ' ' + JSON.parse(activity).length + ' ' + this.translate.instant(Messages.NOTIF_SYNC_OFFLINE_ACTIVITY);
          this.globalService.presentLocalNotification(10, Messages.OFFLINE_ACTIVITY, msg);
        }
      }
    });
  }

  /**
   * *****************************************************
   * RUN EVENTS
   * *****************************************************
   */
  defineEvents() {
    /**
     * SHOW OFFLINE MODE
     */
    this.events.subscribe('OFFLINEMODE:SHOWOFFLINEMODE', (userEventData) => {
      this.isShowOfflineModeMenu = userEventData;
    });

    /**
     * RECORD ATTENDANCE ONLINE
     */
    this.events.subscribe('ATTENDANCE:RECORDATTENDANCEONLINE', (dataRecord) => {
      // this.saveAttendanceOnline(dataRecord)
      this.runRecordAttendance(dataRecord)
    });

    /**
     * RUN ATTENDANCE RECORD OFFLINE
     */
    this.events.subscribe('OFFLINEMODE:RUNSYNCATTENDANCEOFFLINERECORD', (userEventData) => {
      this.saveAttendanceCheck(userEventData);
    });

    /**
     * RUN ACTIVITY RECORD OFFLINE
     */
    this.events.subscribe('OFFLINEMODE:RUNSYNCACTIVITYRECORDOFFLINE', (userEventData) => {
      this.saveActivityRecordCheck(userEventData);
    });

    /**
     * Event saat attendance record dikirim.
     * Record tidak bisa dihapus ketika proses pengiriman.
     */
    this.events.subscribe('OFFLINEMODE:TRIGERISREMOVE', () => {
      this.events.publish('OFFLINEMODE:ISREMOVE', this.isSync);
      this.events.publish('OFFLINEMODE:ISREMOVEACT', this.isSync);
    });

    /**
     *
     */
    this.events.subscribe('OFFLINEMODE:TIMEATTENDANCEPREVIEW', (val) => {
      this.isPagePreviewAttendance = val;
    });

    /**
     * Run
     */
    this.events.subscribe('OFFLINEMODE:RUNPINGGOOGLESERVER', (val) => {
      this.runPingGoogleServer();
    });

    /**
     * Run Go to Offline mode page
     */
    this.events.subscribe('OFFLINEMODE:GOTOOFFLINEMODEPAGE', (val) => {
      this.runOfflineModeMenu();
    });

    this.events.subscribe(EventLabel.OPEN_PAGE, (page) => {
      this.openPage(page);
    });

    this.events.subscribe('user:logout', () => {
      try {
        this.storage.remove('pageBuilderAppMode');
        this.storage.remove('pageBuilderEnv');
      } catch (error) { }
      this.gotoLogout();
    });

    this.events.subscribe('user:setting', () => {
      this.gotoSetting();
    });

    this.events.subscribe('user:getpagebuilder', (page) => {
      this.openBuilderPage(page);
    });

    this.events.subscribe('user:getstaticbuilder', (page) => {
      this.openBuilderStaticPage(page);
    });

    this.events.subscribe('user:appversion', () => {
      this.gotoAppVersion();
    });

    this.events.subscribe('user:created', async (userEventData) => {
      console.log('user:created');
      this.loadPageBuilder()
      this.loadPersonal(userEventData);
      this.loadMultiCompany(userEventData);
      try {
        // console.log('user:created');
        let appMode = await this.storage.get('pageBuilderAppMode');
        // console.log('APP MODE', appMode);

        if (appMode === null || appMode === undefined) {
          // console.log('GET');
          this.apiServiceProvider.getAppMode();
        }
      } catch (error) { };
    });

    this.events.subscribe('user:goToHomePage', (userEventData) => {
      this.nav.push('Home2Page');
      this.runPingerPingServer();
    });

    this.events.subscribe('sideMenuEnable', (value) => {
      this.sideMenuEnable(value);
    });

    this.events.subscribe('toggleLayout', (value) => {
      this.newHome = this.menuService.newHome;
      if (window.innerWidth >= 768 && window.innerWidth <= this.maxMenuTab) {
        this.tambahSize = 'tutupSizeMenu';
      }
      this.initializeBloc.initStatusBar();
    });

    this.pages = this.menuService.pages;
    this.events.subscribe('user:updateUserData', (value) => {
      this.dataEmployee = value;
    });

    this.events.subscribe('attendance:flag', () => {
      this.isSync = false;
    });

    this.events.unsubscribe(EventLabel.LOAD_MENU);
    this.events.subscribe(EventLabel.LOAD_MENU, async () => {
      await this.authenticationBloc.loadAuth();
      this.loadPageBuilder();
      this.menuRepository.getReFavoriteMenu();
    });

    this.events.publish(EventLabel.COMPANY_SWITCH_DONE);
    this.events.subscribe(EventLabel.COMPANY_SWITCH_DONE, async () => {
      this.loadPageBuilder();
      this.menuRepository.getReFavoriteMenu();
    });

    this.events.unsubscribe(EventLabel.OPEN_MAPS_GREATDAY_PAGE);
    this.events.subscribe(EventLabel.OPEN_MAPS_GREATDAY_PAGE, async () => {
      this.nav.push('GreatDayMapsPage');
    });
  }

  /**
 * *****************************************************
 * RUN EVENTS
 * *****************************************************
 */
  unsubcribeEvents() {
    this.events.unsubscribe('OFFLINEMODE:SHOWOFFLINEMODE');
    this.events.unsubscribe('ATTENDANCE:RECORDATTENDANCEONLINE');
    this.events.unsubscribe('OFFLINEMODE:RUNSYNCATTENDANCEOFFLINERECORD');
    this.events.unsubscribe('OFFLINEMODE:RUNSYNCACTIVITYRECORDOFFLINE');
    this.events.unsubscribe('OFFLINEMODE:TRIGERISREMOVE');
    this.events.unsubscribe('OFFLINEMODE:TIMEATTENDANCEPREVIEW');
    this.events.unsubscribe('OFFLINEMODE:RUNPINGGOOGLESERVER');
    this.events.unsubscribe('OFFLINEMODE:GOTOOFFLINEMODEPAGE');
    this.events.unsubscribe('user:openPage');
    this.events.unsubscribe('user:logout');
    this.events.unsubscribe('user:setting');
    this.events.unsubscribe('user:getpagebuilder');
    this.events.unsubscribe('user:getstaticbuilder');
    this.events.unsubscribe('user:appversion');
    this.events.unsubscribe('user:created');
    this.events.unsubscribe('user:goToHomePage');
    this.events.unsubscribe('sideMenuEnable');
    this.events.unsubscribe('toggleLayout');
    this.events.unsubscribe('user:updateUserData');
    this.events.unsubscribe('attendance:flag');
    this.events.unsubscribe('load:menu');
  }

  /**
   * ****************************************************
   * RUN PING GOOGLE AND SERVER
   * ****************************************************
   */
  runPingGoogleServer() {
    // ;
    this.runPingServer = false;
    this.isSync = false;
    setTimeout(() => {
      if (this.isOnline) {
        // ;
        this.runPingerPingServer();
      }
    }, (1000 * 60) * 10);
  }

  /**
   * **************************************************************************************************************
   * END MODULE OFFLINE MODE
   * **************************************************************************************************************
   */

  /**
   * RUN CHANGE STATUS SENDING
   */
  runStatusSending() {
    this.storage.get('SFGoAttendanceLog').then((attendance) => {
      if (attendance != null && attendance != undefined && attendance != "") {
        let attendanceList: any = [...JSON.parse(attendance)].map((value: any) => {
          value.isRunning = false;
          return value;
        });
        this.storage.set('SFGoAttendanceLog', JSON.stringify(attendanceList));
      }
    })
  }


  /**
   * Google analytics Authentication
   */
  googleAnalyticsAuth() {
    // For Web
    this.analyticsProvider.startTrackerWithId('197210230');

    this.nav.viewDidEnter.subscribe(
      (view) => {
        const prev1 = this.nav.getPrevious(view);
        const prev2 = this.nav.getPrevious();

        // handle page builder close app from parent webview
        if (!prev1 && (prev2 && prev2.id === 'PageInitPage')) {
          window.parent.postMessage({ backButtonPageBuilder: true }, '*');
        }

        const viewName = view && view.id ? view.id : 'view_blank';
        this.analyticsProvider.trackEvent(EventNameAnalytics.OPEN_PAGE, viewName);
        this.analyticsProvider.trackView(viewName);
      }
    );
  }

  /**
   * Show modal dialog Notif employee birthday
   */
  async loadMyBirthday() {
    await this.platform.ready();
    const auth = JSON.parse(await this.storage.get('SFGoAuth'));
    try {
      if (auth.menu.birthday) {
        if (!this.loadBirthday) {
          this.loadBirthday = true;
          const hasil = await this.sfProfileApi.getBirthday().toPromise();
          if (hasil.status) {
            const activeBirthday = await this.storage.get('NonActiveBirthday');
            if (!activeBirthday) {
              const storageBirthday = await this.storagePathProvider.getStorageBirthday();
              const modal = this.modalCtrl.create('BirthdayCardPage', {
                "photoUser": auth.photo,
                "nameUser": auth.fullName,
                "greeting": hasil.data.companySetting.greeting,
                "picture": storageBirthday.urlDownload + encodeURIComponent(hasil.data.companySetting.picture),
                "signature_picture": storageBirthday.urlDownload + encodeURIComponent(hasil.data.companySetting.signature),
                "signature_name": hasil.data.companySetting.signer,
                "siganture_position": hasil.data.companySetting.position,
                "lower_picture": storageBirthday.urlDownload + encodeURIComponent(hasil.data.companySetting.logo),
                "userId": auth.userId
              });
              modal.onDidDismiss(data => {
                if (data) {
                  this.storage.set('NonActiveBirthday', data)
                }
              });
              modal.present();
            }
          } else {
            this.storage.set('NonActiveBirthday', undefined);
          }
        }
      }
    } catch (error) {
    }
  }

  /**
   * Get App version
   */
  async getAppVersion() {
    try {
      if (this.platform.is('cordova')) {
        await this.initializeBloc.setAppVersion();
        const appVersion = await this.initializeBloc.checkAppVersion();
        this.appUpdate = appVersion.isUptodate ? false : true;

        if (!appVersion.isUptodate) {
          if (appVersion.isForceUpdate) {
            this.globalService.showConfirmUpdateApps(true, appVersion.message);
          } else if (appVersion.isSoftUpdate) {
            this.globalService.showConfirmUpdateApps(false, appVersion.message);
          }
        }
      }
    } catch (error) { }

    try {
      let appMode = await this.storage.get('pageBuilderAppMode');

      if (appMode === null || appMode === undefined) {
        await this.apiServiceProvider.getAppMode();
      }
    } catch (error) { }

    try {
      const auth = await this.appPreferences.getAuth();
      if (auth.id) {
        this.versionServiceProvider.getVersion();
      }
    } catch (error) { }
  }

  /**
   * ALERT FOR REDIRECT UPDATE TO PLAYSTORE OR APPSTORE
   * @param enableBack
   */
  presentAlert(isForceUpdate: boolean) {
    // let status: boolean = enableBack;
    let url = "https://play.google.com/store/apps/details?id=com.dataon.sunfishgo";
    if (this.platform.is("ios")) {
      url = "https://itunes.apple.com/id/app/greatday-hr-sunfish-go/id1149720670?l=id&mt=8";
    }

    const alert = this.alertCtrl.create({
      title: this.translate.instant(Messages.INFORMATION),
      message: this.translate.instant('Please update app to get the latest features, improvements, and bug fixes'),
      // cssClass: 'appVersionAlert',
      enableBackdropDismiss: false
    });

    if (!isForceUpdate) {
      alert.addButton({
        text: this.translate.instant('Skip'),
        handler: () => {
          alert.dismiss();
        }
      })
    }

    alert.addButton({
      text: this.translate.instant('Update Now'),
      handler: () => {
        this.inAppBrowser.create(url, '_system');
        cordova.plugins.exit();
      }
    });

    if (isForceUpdate) {
      this.platform.backButton.subscribe(() => {
        cordova.plugins.exit();
      })
    }
    alert.present();
  }

  /**
   * For Detect browser refresh on website only
   */
  detectBrowserRefresh() {
    if (!this.platform.is('cordova')) {
      window.onload = async () => {
        if (this.nav.getActive()) {
          if (this.nav.getActive().name != 'Home2Page' && this.nav.getActive().name != 'ForgotPass2Page') {
            console.log('masuk sini babay');
            let auth = await this.storage.get("SFGoAuth");
            if (JSON.parse(auth)) {
              if (auth.id) {
                this.events.publish('user:created', {});
              }
            }
          }
        }
      }
    }
  }

  goToCalculating() {
    this.nav.push('PayrollFramePage', {
      setStep: 2,
    })
  }

  passwordToast(msg: string, dot: string = "") {
    let toast = this.toastCtrl.create({
      message: this.translate.instant(msg) + dot,
      position: 'top',
      duration: 3000,
      showCloseButton: false,
      closeButtonText: 'x',
      cssClass: "custom-toast",
      dismissOnPageChange: false
    });
    return toast;
  }

  sideScroll() {
    this.sidebarScroll = this.content.scrollTop;
  }

  payrollQueue() {
    this.socketIoClientProvider.queueSubject.subscribe((res) => {
      this.userIdProcessBy = res[0].userId
      this.empIdProcessBy = res[0].empId
      this.update(res[0].tracks.length, res[0].totalProcess);
    });

    this.socketIoClientProvider.baloonSubject.subscribe((res) => {
      this.toggleHide = res;
    });
  }

  regionLoading() {
    this.halfDiameter = this.diameter / 2;
    this.radius = this.halfDiameter - (this.borderWidth * 2);
    this.diameterStretch = this.radius * 2 * Math.PI;
    this.circlePercentage = Math.floor((this.loadFile / this.totalFile) * 100);
    this.circleProgress = this.diameterStretch - this.loadFile / this.totalFile * this.diameterStretch;
  }

  closeSnackbar() {
    this.toggleSnackbar = false;
  }

  toOfflineList() {
    let modal = this.modalCtrl.create('OfflineModeListPage', { mode: 'modal' }, { cssClass: "gd-modal-radius" });
    modal.present();
  }

  async loadGoPathNew() {
    let SFGoStorage = await this.sfgoAuthService.getGDStorage();
    let storedPrelogin = SFGoStorage.storedPrelogin;
    if (storedPrelogin.hasOwnProperty('GOPATHNEW')) {
      this.goPathNew = true;
    } else {
      this.goPathNew = false;
    }
  }

  /**
   * condition go to homepage if running with browser
   */
  reloadToRoot() {
    if (!this.platform.is('cordova')) {
      window.onload = async () => {

        console.log('reloadToRoot');
        let refresh = true;
        try {
          console.log('document.URL', document.URL);
          if (document.URL.indexOf("?") > 0) {
            console.log('document.URL', document.URL);
            let splitURL = document.URL.split("?");
            let splitParams = splitURL[1].split("&");
            let i: any;
            for (i in splitParams) {
              console.log("i", i);
              console.log("singleURLParam", splitParams);
              let singleURLParam = splitParams[i].split('=');
              console.log("singleURLParam", singleURLParam);
              if (singleURLParam[0] == "dontRefresh") {
                refresh = false;
              }
              if (singleURLParam[0] == "pageCode") {
                this.storage.set("pageBuilderFramePageCode", singleURLParam[1]);
              }
            };
          }

          if (!refresh) return;
        } catch (error) { };

        console.log("refresh", refresh);
        console.log('document.URL', document.URL);
        if (refresh) {
          this.storage.get('SFGoAuth').then(hasil => {
            try {
              let data = JSON.parse(hasil);
              if (this.nav.getActive() && data && data.id) {
                if (
                  this.nav.getActive().id !== 'PageInitPage' &&
                  this.nav.getActive().id !== 'ChangePassPage' &&
                  this.nav.getActive().id !== 'change-pass' &&
                  this.nav.getActive().id !== 'PollingWelcomePage' &&
                  this.nav.getActive().id !== 'ForgotPass2Page' &&
                  this.android == null && this.nav.getActive().id !== 'InitPageBuilder' &&
                  !this.runIframe
                ) {
                  console.log('masuk reload page init');
                  this.nav.setRoot('PageInitPage');
                }
              }
            } catch (err) {
              console.log("bayu 22", err, this.android);
            }
          });
        }
      }
    }
  }

  /**
   * event triger if browser navigation
   */
  onClickBrowserNavigation() {
    if (!this.platform.is('cordova')) {
      document.onmouseover = function () {
        window.innerDocClick = true;
      }
      document.onmouseout = function () {
        window.innerDocClick = false;
      }
      window.onhashchange = async () => {
        if (window.innerDocClick) {
        } else {
          //Browser back button was clicked
          this.storage.get('SFGoAuth').then(hasil => {
            try {
              let data = JSON.parse(hasil);
              if (this.nav.getActive() && data.id) {
                if (
                  this.nav.getActive().id !== 'Home2Page' &&
                  this.nav.getActive().id !== 'ChangePassPage' &&
                  this.nav.getActive().id !== 'home2' &&
                  this.nav.getActive().id !== 'change-pass' &&
                  this.nav.getActive().id !== 'PollingWelcomePage' &&
                  this.android == null &&
                  this.nav.getActive().id !== 'InitPageBuilder' &&
                  this.nav.getActive().id !== 'ForgotPass2Page' &&
                  !this.runIframe
                ) {
                  this.nav.setRoot(RootPage.page).then(() => {
                    window.location.reload();
                  });
                }
              }
            } catch (err) {
              console.log("bayu 1", err, this.android);
            }
          });
        }
      }
    }
  }

  async stopTracking(): Promise<void> {
    const checkStatus = await this.backgroundGeolocationNative.checkStatus();

    if (checkStatus.isRunning) {
      this.backgroundGeolocationNative.stop();

      const location = await this.geolocationNative.getCurrentPosition({
        enableHighAccuracy: true
      });

      try {
        const SFGoAuth = JSON.parse(await this.storage.get('SFGoAuth'));
        const stop = await this.trackerApi.end([{
          empId: SFGoAuth.empId,
          location: {
            longitude: location.coords.longitude.toString(),
            latitude: location.coords.latitude.toString(),
          },
          logTime: moment().format(),
        }]).toPromise();

        console.log('stop', stop);
      } catch (e) {
        console.log('error trackerApi.stop()', e);
      }
    }
  }

  dismissToast(toast: Toast) {
    toast.onDidDismiss(async () => {
      const pages = [TimeAttendanceSfgoPage, TimeAttendance, Home2Page, AttendanceResultPage, HomePage];
      const activeNav = this.app.getActiveNav().getActive();
      let count = 0;
      pages.map(page => {
        if (activeNav.instance instanceof page) count++;
      })
      if (count > 0) await this.navigationService.push('AttendanceTrackerNotificationPage');
    });

    setTimeout(async () => {
      const checkStatus = await this.backgroundGeolocationNative.checkStatus();
      if (checkStatus.isRunning) await toast.present();
    }, 3000);
  }

  loadFavMenu() {
    this.menuRepository.getReFavoriteMenu();
  }

  callbackGdToast(e) {
    if (e.ctaClose) {
      this.toastList = this.toastList.filter((el) => el.title !== e.title);
    } else {
      this.events.publish('toastCallback', e);
    }
  }

  async initIdleTime() {
    try {
      // if (this.SFGoAuth.id) {

      //   //Start watching for user inactivity.
      //   this.userIdle.startWatching();

      //   // Start watching when user idle is starting.
      //   this.userIdle.onTimerStart().subscribe(count => {
      //     console.log('Start watching when user idle is starting.', count);
      //   });

      //   // Start watch when time is up.
      //   this.userIdle.onTimeout().subscribe(() => {
      //     const modal = this.modalCtrl.create('FingerprintPage', {
      //       data: {
      //         featureCode: 'idleMethod',
      //         disabledBackButton: true,
      //       }
      //     });
      //     modal.onDidDismiss(_ => {
      //       this.userIdle.resetTimer();
      //     });
      //     modal.present();
      //   });
      // }
    } catch (error) { }
  }

  getPollingResume() {
    this.pollingBloc.checkPollingFromServer();
  }

  async getInfoIdfa() {
    await this.platform.ready();
    this.askTrackingPermission();
    this.readTrackingPermission();
  }

  askTrackingPermission() {
    if (this.platform.is('cordova') && this.platform.is('ios')) {
      if (window.cordova) {
        console.log('trying to request permission ');
        window.cordova.exec(win, fail, 'idfa', "requestPermission", []);
      }
    }
    function win(res) {
      console.log('success ' + JSON.stringify(res));
    }
    function fail(res) {
      console.log('fail ' + JSON.stringify(res));
    }
  }

  readTrackingPermission() {
    if (this.platform.is('cordova') && this.platform.is('ios')) {
      if (window.cordova) {
        window.cordova.exec(win, fail, 'idfa', "getInfo", []);
      }
    }
    function win(res) {
      console.log('success  ' + JSON.stringify(res));
    }
    function fail(res) {
      console.log('fail ' + JSON.stringify(res));
    }
  }

  async loadVersionApps() {
    let deviceInfo = await this.appPreferences.getGreatdayStorage<any>(Preference.GDDeviceInfo);
    if (!deviceInfo) {
      deviceInfo = await this.platformServiceProvider.getPlatform();
    }
    const versionApss = {
      code: deviceInfo.SFGOVersionCode,
      number: deviceInfo.SFGOVersionNumber
    }
    localStorage.setItem('$version_apps', JSON.stringify(versionApss));
  }

  async loadCheckTempering() {
    try {
      await this.platform.ready();
      if (this.platform.is('cordova')) {
        if (this.platform.is('android')) {
          const me = this;
          window.cordova.plugins.AntiTampering.verify(
            function (success) {
              console.info(success);
              // {"assets": {"count": x}} - where x is the number of assets checked
            },
            async function (error) {
              console.error(error);
              await me.alertService.createMola(me.translate.instant("This application has been changed by another party, please use the original version from the official store"));
              cordova.plugins.exit();
            }
          );
        }
        if (this.platform.is('ios')) {
          const me = this;
          const packageName = await this.appVersion.getPackageName() || 'com.dataon.sunfishgo';
          SecurityCheck.isTampered(packageName, async (data) => {
            if (data) {
              await me.alertService.createMola(me.translate.instant("This application has been changed by another party, please use the original version from the official store"));
              cordova.plugins.exit();
            }
          }, (error) => {
            console.log('error isTampered', error);
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async checkRunOnVirtual() {
    try {
      await this.platform.ready();
      if (this.platform.is('cordova')) {
        const isEmu = await this.isRunningOnEmulator();
        if (this.device.isVirtual || isEmu) {
          await this.alertService.createMola(this.translate.instant("This app cannot run on virtual devices"));
          cordova.plugins.exit();
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  async checkReverseEngineering() {
    try {
      await this.platform.ready();
      if (this.platform.is('cordova')) {
        const isReverseEngineeringDetected = await this.isReverseEngineeringDetected();
        if (isReverseEngineeringDetected) {
          // await this.alertService.createMola(this.translate.instant("Reverse engineering detected"));
          alert("A reverse engineering tool is detected on this device. You are not allowed to proceed.");
          cordova.plugins.exit();
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  isRunningOnEmulator(): Promise<any> {
    return new Promise((res, rej) => {
      try {
        if (this.platform.is('ios')) {
          SecurityCheck.isEmulationDetected((data) => {
            res(data);
          }, (error) => {
            rej(error)
          });
        }
        if (this.platform.is('android')) {
          greatdayplugin.isEmulator((booleanVal) => {
            res(booleanVal);
          }, (err) => {
            rej(err)
          });
        }
      } catch (e) {
        rej(e)
      }
    })
  }

  isReverseEngineeringDetected() {
    return new Promise((resolve, reject) => {
      if (this.platform.is('android')) {
        resolve(false);
      }
      if (this.platform.is('ios')) {
        SecurityCheck.isReverseEngineeringDetected((data) => {
          resolve(data);
        }, (error) => {
          reject(error);
        });
      }
    })
  }

  updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  }

  initHomeMobile() {
    this.navigationService.setRoot(this.activeTab);
  }

  toProfile() {
    console.log('toProfile');
  }

  search() {
    let modal = this.modalCtrl.create('EmpListPage', { popBack: {} }, { cssClass: "" });
    modal.present();
  }

  openfeature() {
    let modal = this.modalCtrl.create('FeaturesSf7Page', {}, { cssClass: "" });
    modal.present();
  }

  moveTab(route) {
    console.log('moveTab1', route);
    this.activeTab = route;
    this.navigationService.setRoot(this.activeTab, { fromTabs: true });
  }

  async initLocalTime() {
    try {
      await this.platform.ready();
      if (this.platform.is('cordova') && this.platform.is('ios')) {
        const localTime = localStorage.getItem('$initLocalTime');
        const milliseconds = new Date().getTime();
        if (localTime) {
          if (milliseconds >= parseInt(localTime)) {
            localStorage.setItem('$initLocalTime', `${milliseconds}`);
          } else {
            alert(this.translate.instant("We identified that the time on your device does not match the current time."));
            this.diagnostic.switchToSettings();
          }
        } else {
          localStorage.setItem('$initLocalTime', `${milliseconds}`);
        }
      }
    } catch (error) {
      console.log('initLocalTime', error);
    }
  }

  loadSettingScreenshot(setting: boolean) {
    if (this.platform.is('cordova')) {
      try {
        if (setting) {
          this.screenshotNative.disabledScreenshot();
        } else {
          this.screenshotNative.enableScreenshot();
        }
      } catch (error) {
        this.screenshotNative.enableScreenshot();
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts